import { EDomainClass } from './DomainClass'

//  ///////////////////////
//  MARK: TYPES
export interface IDomainTreeNode {
  className: EDomainClass
  classNames: readonly EDomainClass[]
  children: TDomainTree
}

export type TDomainTree = {
  [key in EDomainClass]?: IDomainTreeNode
}

//  ///////////////////////
//  MARK: EXPORTS
export const DomainTree = {
  [EDomainClass.Aircraft]: {
    className: EDomainClass.Aircraft,
    classNames: [EDomainClass.Aircraft],
    children: {},
  },
  [EDomainClass.AircraftCleaning]: {
    className: EDomainClass.AircraftCleaning,
    classNames: [EDomainClass.AircraftCleaning],
    children: {},
  },
  [EDomainClass.AircraftConfiguration]: {
    className: EDomainClass.AircraftConfiguration,
    classNames: [EDomainClass.AircraftConfiguration],
    children: {},
  },
  [EDomainClass.AircraftConfigurationAvailability]: {
    className: EDomainClass.AircraftConfigurationAvailability,
    classNames: [EDomainClass.AircraftConfigurationAvailability],
    children: {},
  },
  [EDomainClass.AircraftConfigurationInstallation]: {
    className: EDomainClass.AircraftConfigurationInstallation,
    classNames: [EDomainClass.AircraftConfigurationInstallation],
    children: {},
  },
  [EDomainClass.AircraftMonthlyFee]: {
    className: EDomainClass.AircraftMonthlyFee,
    classNames: [EDomainClass.AircraftMonthlyFee],
    children: {},
  },
  [EDomainClass.AircraftMonthlyStatement]: {
    className: EDomainClass.AircraftMonthlyStatement,
    classNames: [EDomainClass.AircraftMonthlyStatement],
    children: {},
  },
  [EDomainClass.AircraftRate]: {
    className: EDomainClass.AircraftRate,
    classNames: [EDomainClass.AircraftRate],
    children: {},
  },
  [EDomainClass.AircraftType]: {
    className: EDomainClass.AircraftType,
    classNames: [EDomainClass.AircraftType],
    children: {},
  },
  [EDomainClass.AircraftTypePhoto]: {
    className: EDomainClass.AircraftTypePhoto,
    classNames: [EDomainClass.AircraftTypePhoto],
    children: {},
  },
  [EDomainClass.Airport]: {
    className: EDomainClass.Airport,
    classNames: [EDomainClass.Airport],
    children: {},
  },
  [EDomainClass.AirportCostEstimate]: {
    className: EDomainClass.AirportCostEstimate,
    classNames: [EDomainClass.AirportCostEstimate],
    children: {},
  },
  [EDomainClass.AirportFuelPriceWeekly]: {
    className: EDomainClass.AirportFuelPriceWeekly,
    classNames: [EDomainClass.AirportFuelPriceWeekly],
    children: {},
  },
  [EDomainClass.BaseLocation]: {
    className: EDomainClass.BaseLocation,
    classNames: [EDomainClass.BaseLocation],
    children: {},
  },
  [EDomainClass.ExpenseItem]: {
    className: EDomainClass.ExpenseItem,
    classNames: [
      EDomainClass.ExpenseItem,
      EDomainClass.CarRefueling,
      EDomainClass.HotelStay,
      EDomainClass.Refueling,
      EDomainClass.BelgianDepartingFlightTaxesExpenseItem,
      EDomainClass.ItalianFlightTaxesExpenseItem,
    ],
    children: {
      [EDomainClass.CarRefueling]: {
        className: EDomainClass.CarRefueling,
        classNames: [EDomainClass.CarRefueling],
        children: {},
      },
      [EDomainClass.HotelStay]: {
        className: EDomainClass.HotelStay,
        classNames: [EDomainClass.HotelStay],
        children: {},
      },
      [EDomainClass.Refueling]: {
        className: EDomainClass.Refueling,
        classNames: [EDomainClass.Refueling],
        children: {},
      },
      [EDomainClass.BelgianDepartingFlightTaxesExpenseItem]: {
        className: EDomainClass.BelgianDepartingFlightTaxesExpenseItem,
        classNames: [EDomainClass.BelgianDepartingFlightTaxesExpenseItem],
        children: {},
      },
      [EDomainClass.ItalianFlightTaxesExpenseItem]: {
        className: EDomainClass.ItalianFlightTaxesExpenseItem,
        classNames: [EDomainClass.ItalianFlightTaxesExpenseItem],
        children: {},
      },
    },
  },
  [EDomainClass.Country]: {
    className: EDomainClass.Country,
    classNames: [EDomainClass.Country],
    children: {},
  },
  [EDomainClass.CrewCompositionRule]: {
    className: EDomainClass.CrewCompositionRule,
    classNames: [EDomainClass.CrewCompositionRule],
    children: {},
  },
  [EDomainClass.CrewCompositionSettings]: {
    className: EDomainClass.CrewCompositionSettings,
    classNames: [EDomainClass.CrewCompositionSettings],
    children: {},
  },
  [EDomainClass.CrewDailyAllowance]: {
    className: EDomainClass.CrewDailyAllowance,
    classNames: [EDomainClass.CrewDailyAllowance],
    children: {},
  },
  [EDomainClass.CrewDailyAllowanceTable]: {
    className: EDomainClass.CrewDailyAllowanceTable,
    classNames: [EDomainClass.CrewDailyAllowanceTable],
    children: {},
  },
  [EDomainClass.CrewMealShare]: {
    className: EDomainClass.CrewMealShare,
    classNames: [EDomainClass.CrewMealShare],
    children: {},
  },
  [EDomainClass.CrewSeating]: {
    className: EDomainClass.CrewSeating,
    classNames: [EDomainClass.CrewSeating],
    children: {},
  },
  [EDomainClass.DataMigration]: {
    className: EDomainClass.DataMigration,
    classNames: [EDomainClass.DataMigration],
    children: {},
  },
  [EDomainClass.DigitalFile]: {
    className: EDomainClass.DigitalFile,
    classNames: [EDomainClass.DigitalFile],
    children: {},
  },
  [EDomainClass.DigitalFileExact]: {
    className: EDomainClass.DigitalFileExact,
    classNames: [EDomainClass.DigitalFileExact],
    children: {},
  },
  [EDomainClass.Entity]: {
    className: EDomainClass.Entity,
    classNames: [
      EDomainClass.Entity,
      EDomainClass.Organisation,
      EDomainClass.Person,
      EDomainClass.User,
    ],
    children: {
      [EDomainClass.Organisation]: {
        className: EDomainClass.Organisation,
        classNames: [EDomainClass.Organisation],
        children: {},
      },
      [EDomainClass.Person]: {
        className: EDomainClass.Person,
        classNames: [EDomainClass.Person, EDomainClass.User],
        children: {
          [EDomainClass.User]: {
            className: EDomainClass.User,
            classNames: [EDomainClass.User],
            children: {},
          },
        },
      },
    },
  },
  [EDomainClass.ExpenseCategory]: {
    className: EDomainClass.ExpenseCategory,
    classNames: [EDomainClass.ExpenseCategory],
    children: {},
  },
  [EDomainClass.ExpenseCategoryConfiguration]: {
    className: EDomainClass.ExpenseCategoryConfiguration,
    classNames: [EDomainClass.ExpenseCategoryConfiguration],
    children: {},
  },
  [EDomainClass.ExpenseDraft]: {
    className: EDomainClass.ExpenseDraft,
    classNames: [EDomainClass.ExpenseDraft],
    children: {},
  },
  [EDomainClass.Flight]: {
    className: EDomainClass.Flight,
    classNames: [EDomainClass.Flight],
    children: {},
  },
  [EDomainClass.FlightShare]: {
    className: EDomainClass.FlightShare,
    classNames: [EDomainClass.FlightShare],
    children: {},
  },
  [EDomainClass.GroundEvent]: {
    className: EDomainClass.GroundEvent,
    classNames: [EDomainClass.GroundEvent],
    children: {},
  },
  [EDomainClass.MemberRate]: {
    className: EDomainClass.MemberRate,
    classNames: [EDomainClass.MemberRate],
    children: {},
  },
  [EDomainClass.Membership]: {
    className: EDomainClass.Membership,
    classNames: [EDomainClass.Membership],
    children: {},
  },
  [EDomainClass.MembershipSubscription]: {
    className: EDomainClass.MembershipSubscription,
    classNames: [EDomainClass.MembershipSubscription],
    children: {},
  },
  [EDomainClass.MembershipSubscriptionAssociatedMember]: {
    className: EDomainClass.MembershipSubscriptionAssociatedMember,
    classNames: [EDomainClass.MembershipSubscriptionAssociatedMember],
    children: {},
  },
  [EDomainClass.MembershipSubscriptionFile]: {
    className: EDomainClass.MembershipSubscriptionFile,
    classNames: [EDomainClass.MembershipSubscriptionFile],
    children: {},
  },
  [EDomainClass.MenuItem]: {
    className: EDomainClass.MenuItem,
    classNames: [EDomainClass.MenuItem],
    children: {},
  },
  [EDomainClass.Mission]: {
    className: EDomainClass.Mission,
    classNames: [EDomainClass.Mission],
    children: {},
  },
  [EDomainClass.MissionForfait]: {
    className: EDomainClass.MissionForfait,
    classNames: [EDomainClass.MissionForfait],
    children: {},
  },
  [EDomainClass.MissionHolderChoice]: {
    className: EDomainClass.MissionHolderChoice,
    classNames: [EDomainClass.MissionHolderChoice],
    children: {},
  },
  [EDomainClass.MonthlyExperience]: {
    className: EDomainClass.MonthlyExperience,
    classNames: [EDomainClass.MonthlyExperience],
    children: {},
  },
  [EDomainClass.MonthlyExperienceByAircraftType]: {
    className: EDomainClass.MonthlyExperienceByAircraftType,
    classNames: [EDomainClass.MonthlyExperienceByAircraftType],
    children: {},
  },
  [EDomainClass.ParticipationOperation]: {
    className: EDomainClass.ParticipationOperation,
    classNames: [EDomainClass.ParticipationOperation],
    children: {},
  },
  [EDomainClass.ParticipationOperationLine]: {
    className: EDomainClass.ParticipationOperationLine,
    classNames: [EDomainClass.ParticipationOperationLine],
    children: {},
  },
  [EDomainClass.ParticipationOperationReinvoice]: {
    className: EDomainClass.ParticipationOperationReinvoice,
    classNames: [EDomainClass.ParticipationOperationReinvoice],
    children: {},
  },
  [EDomainClass.PerformanceStep]: {
    className: EDomainClass.PerformanceStep,
    classNames: [EDomainClass.PerformanceStep],
    children: {},
  },
  [EDomainClass.PilotQualification]: {
    className: EDomainClass.PilotQualification,
    classNames: [EDomainClass.PilotQualification],
    children: {},
  },
  [EDomainClass.PushDevice]: {
    className: EDomainClass.PushDevice,
    classNames: [EDomainClass.PushDevice],
    children: {},
  },
  [EDomainClass.Role]: {
    className: EDomainClass.Role,
    classNames: [EDomainClass.Role],
    children: {},
  },
  [EDomainClass.Runway]: {
    className: EDomainClass.Runway,
    classNames: [EDomainClass.Runway],
    children: {},
  },
  [EDomainClass.Timer]: {
    className: EDomainClass.Timer,
    classNames: [EDomainClass.Timer],
    children: {},
  },
  [EDomainClass.TimerIndex]: {
    className: EDomainClass.TimerIndex,
    classNames: [EDomainClass.TimerIndex],
    children: {},
  },
  [EDomainClass.UserAgendaAircraftPreference]: {
    className: EDomainClass.UserAgendaAircraftPreference,
    classNames: [EDomainClass.UserAgendaAircraftPreference],
    children: {},
  },
  [EDomainClass.UserResetPassword]: {
    className: EDomainClass.UserResetPassword,
    classNames: [EDomainClass.UserResetPassword],
    children: {},
  },
  [EDomainClass.UserRole]: {
    className: EDomainClass.UserRole,
    classNames: [EDomainClass.UserRole],
    children: {},
  },
  [EDomainClass.AccountMouvement]: {
    className: EDomainClass.AccountMouvement,
    classNames: [
      EDomainClass.AccountMouvement,
      EDomainClass.AccountMouvementDocument,
      EDomainClass.AccountMouvementFiscalDocument,
      EDomainClass.Expense,
      EDomainClass.BelgianDepartingFlightTaxesExpense,
      EDomainClass.ItalianFlightTaxesExpense,
      EDomainClass.StockIssueExpense,
      EDomainClass.Invoice,
      EDomainClass.AircraftOwnerInvoice,
      EDomainClass.MissionInvoice,
      EDomainClass.BelgianDepartingFlightTaxesExpense,
      EDomainClass.ItalianFlightTaxesExpense,
      EDomainClass.StockIssueExpense,
      EDomainClass.AircraftOwnerInvoice,
      EDomainClass.MissionInvoice,
      EDomainClass.DirectPosting,
      EDomainClass.Instalment,
      EDomainClass.IntermediaryAgencyPaymentCollection,
      EDomainClass.LoanMovement,
      EDomainClass.PersonalExpenseAccountMouvementDocument,
      EDomainClass.WagePayment,
      EDomainClass.Expense,
      EDomainClass.BelgianDepartingFlightTaxesExpense,
      EDomainClass.ItalianFlightTaxesExpense,
      EDomainClass.StockIssueExpense,
      EDomainClass.Invoice,
      EDomainClass.AircraftOwnerInvoice,
      EDomainClass.MissionInvoice,
      EDomainClass.BelgianDepartingFlightTaxesExpense,
      EDomainClass.ItalianFlightTaxesExpense,
      EDomainClass.StockIssueExpense,
      EDomainClass.AircraftOwnerInvoice,
      EDomainClass.MissionInvoice,
      EDomainClass.Payment,
      EDomainClass.BankAccountPayment,
      EDomainClass.CashPayment,
      EDomainClass.CreditCardPayment,
      EDomainClass.ExactPayment,
      EDomainClass.ExactSettlementPayment,
      EDomainClass.IntermediaryAgencyPayment,
      EDomainClass.InternalPayment,
      EDomainClass.PersonalExpenseMonthlyStatementPayment,
      EDomainClass.PersonalExpensePayment,
    ],
    children: {
      [EDomainClass.AccountMouvementDocument]: {
        className: EDomainClass.AccountMouvementDocument,
        classNames: [
          EDomainClass.AccountMouvementDocument,
          EDomainClass.AccountMouvementFiscalDocument,
          EDomainClass.Expense,
          EDomainClass.BelgianDepartingFlightTaxesExpense,
          EDomainClass.ItalianFlightTaxesExpense,
          EDomainClass.StockIssueExpense,
          EDomainClass.Invoice,
          EDomainClass.AircraftOwnerInvoice,
          EDomainClass.MissionInvoice,
          EDomainClass.BelgianDepartingFlightTaxesExpense,
          EDomainClass.ItalianFlightTaxesExpense,
          EDomainClass.StockIssueExpense,
          EDomainClass.AircraftOwnerInvoice,
          EDomainClass.MissionInvoice,
          EDomainClass.DirectPosting,
          EDomainClass.Instalment,
          EDomainClass.IntermediaryAgencyPaymentCollection,
          EDomainClass.LoanMovement,
          EDomainClass.PersonalExpenseAccountMouvementDocument,
          EDomainClass.WagePayment,
          EDomainClass.Expense,
          EDomainClass.BelgianDepartingFlightTaxesExpense,
          EDomainClass.ItalianFlightTaxesExpense,
          EDomainClass.StockIssueExpense,
          EDomainClass.Invoice,
          EDomainClass.AircraftOwnerInvoice,
          EDomainClass.MissionInvoice,
          EDomainClass.BelgianDepartingFlightTaxesExpense,
          EDomainClass.ItalianFlightTaxesExpense,
          EDomainClass.StockIssueExpense,
          EDomainClass.AircraftOwnerInvoice,
          EDomainClass.MissionInvoice,
        ],
        children: {
          [EDomainClass.AccountMouvementFiscalDocument]: {
            className: EDomainClass.AccountMouvementFiscalDocument,
            classNames: [
              EDomainClass.AccountMouvementFiscalDocument,
              EDomainClass.Expense,
              EDomainClass.BelgianDepartingFlightTaxesExpense,
              EDomainClass.ItalianFlightTaxesExpense,
              EDomainClass.StockIssueExpense,
              EDomainClass.Invoice,
              EDomainClass.AircraftOwnerInvoice,
              EDomainClass.MissionInvoice,
              EDomainClass.BelgianDepartingFlightTaxesExpense,
              EDomainClass.ItalianFlightTaxesExpense,
              EDomainClass.StockIssueExpense,
              EDomainClass.AircraftOwnerInvoice,
              EDomainClass.MissionInvoice,
            ],
            children: {
              [EDomainClass.Expense]: {
                className: EDomainClass.Expense,
                classNames: [
                  EDomainClass.Expense,
                  EDomainClass.BelgianDepartingFlightTaxesExpense,
                  EDomainClass.ItalianFlightTaxesExpense,
                  EDomainClass.StockIssueExpense,
                ],
                children: {
                  [EDomainClass.BelgianDepartingFlightTaxesExpense]: {
                    className: EDomainClass.BelgianDepartingFlightTaxesExpense,
                    classNames: [EDomainClass.BelgianDepartingFlightTaxesExpense],
                    children: {},
                  },
                  [EDomainClass.ItalianFlightTaxesExpense]: {
                    className: EDomainClass.ItalianFlightTaxesExpense,
                    classNames: [EDomainClass.ItalianFlightTaxesExpense],
                    children: {},
                  },
                  [EDomainClass.StockIssueExpense]: {
                    className: EDomainClass.StockIssueExpense,
                    classNames: [EDomainClass.StockIssueExpense],
                    children: {},
                  },
                },
              },
              [EDomainClass.Invoice]: {
                className: EDomainClass.Invoice,
                classNames: [
                  EDomainClass.Invoice,
                  EDomainClass.AircraftOwnerInvoice,
                  EDomainClass.MissionInvoice,
                ],
                children: {
                  [EDomainClass.AircraftOwnerInvoice]: {
                    className: EDomainClass.AircraftOwnerInvoice,
                    classNames: [EDomainClass.AircraftOwnerInvoice],
                    children: {},
                  },
                  [EDomainClass.MissionInvoice]: {
                    className: EDomainClass.MissionInvoice,
                    classNames: [EDomainClass.MissionInvoice],
                    children: {},
                  },
                },
              },
              [EDomainClass.BelgianDepartingFlightTaxesExpense]: {
                className: EDomainClass.BelgianDepartingFlightTaxesExpense,
                classNames: [EDomainClass.BelgianDepartingFlightTaxesExpense],
                children: {},
              },
              [EDomainClass.ItalianFlightTaxesExpense]: {
                className: EDomainClass.ItalianFlightTaxesExpense,
                classNames: [EDomainClass.ItalianFlightTaxesExpense],
                children: {},
              },
              [EDomainClass.StockIssueExpense]: {
                className: EDomainClass.StockIssueExpense,
                classNames: [EDomainClass.StockIssueExpense],
                children: {},
              },
              [EDomainClass.AircraftOwnerInvoice]: {
                className: EDomainClass.AircraftOwnerInvoice,
                classNames: [EDomainClass.AircraftOwnerInvoice],
                children: {},
              },
              [EDomainClass.MissionInvoice]: {
                className: EDomainClass.MissionInvoice,
                classNames: [EDomainClass.MissionInvoice],
                children: {},
              },
            },
          },
          [EDomainClass.DirectPosting]: {
            className: EDomainClass.DirectPosting,
            classNames: [EDomainClass.DirectPosting],
            children: {},
          },
          [EDomainClass.Instalment]: {
            className: EDomainClass.Instalment,
            classNames: [EDomainClass.Instalment],
            children: {},
          },
          [EDomainClass.IntermediaryAgencyPaymentCollection]: {
            className: EDomainClass.IntermediaryAgencyPaymentCollection,
            classNames: [EDomainClass.IntermediaryAgencyPaymentCollection],
            children: {},
          },
          [EDomainClass.LoanMovement]: {
            className: EDomainClass.LoanMovement,
            classNames: [EDomainClass.LoanMovement],
            children: {},
          },
          [EDomainClass.PersonalExpenseAccountMouvementDocument]: {
            className: EDomainClass.PersonalExpenseAccountMouvementDocument,
            classNames: [EDomainClass.PersonalExpenseAccountMouvementDocument],
            children: {},
          },
          [EDomainClass.WagePayment]: {
            className: EDomainClass.WagePayment,
            classNames: [EDomainClass.WagePayment],
            children: {},
          },
          [EDomainClass.Expense]: {
            className: EDomainClass.Expense,
            classNames: [
              EDomainClass.Expense,
              EDomainClass.BelgianDepartingFlightTaxesExpense,
              EDomainClass.ItalianFlightTaxesExpense,
              EDomainClass.StockIssueExpense,
            ],
            children: {
              [EDomainClass.BelgianDepartingFlightTaxesExpense]: {
                className: EDomainClass.BelgianDepartingFlightTaxesExpense,
                classNames: [EDomainClass.BelgianDepartingFlightTaxesExpense],
                children: {},
              },
              [EDomainClass.ItalianFlightTaxesExpense]: {
                className: EDomainClass.ItalianFlightTaxesExpense,
                classNames: [EDomainClass.ItalianFlightTaxesExpense],
                children: {},
              },
              [EDomainClass.StockIssueExpense]: {
                className: EDomainClass.StockIssueExpense,
                classNames: [EDomainClass.StockIssueExpense],
                children: {},
              },
            },
          },
          [EDomainClass.Invoice]: {
            className: EDomainClass.Invoice,
            classNames: [
              EDomainClass.Invoice,
              EDomainClass.AircraftOwnerInvoice,
              EDomainClass.MissionInvoice,
            ],
            children: {
              [EDomainClass.AircraftOwnerInvoice]: {
                className: EDomainClass.AircraftOwnerInvoice,
                classNames: [EDomainClass.AircraftOwnerInvoice],
                children: {},
              },
              [EDomainClass.MissionInvoice]: {
                className: EDomainClass.MissionInvoice,
                classNames: [EDomainClass.MissionInvoice],
                children: {},
              },
            },
          },
          [EDomainClass.BelgianDepartingFlightTaxesExpense]: {
            className: EDomainClass.BelgianDepartingFlightTaxesExpense,
            classNames: [EDomainClass.BelgianDepartingFlightTaxesExpense],
            children: {},
          },
          [EDomainClass.ItalianFlightTaxesExpense]: {
            className: EDomainClass.ItalianFlightTaxesExpense,
            classNames: [EDomainClass.ItalianFlightTaxesExpense],
            children: {},
          },
          [EDomainClass.StockIssueExpense]: {
            className: EDomainClass.StockIssueExpense,
            classNames: [EDomainClass.StockIssueExpense],
            children: {},
          },
          [EDomainClass.AircraftOwnerInvoice]: {
            className: EDomainClass.AircraftOwnerInvoice,
            classNames: [EDomainClass.AircraftOwnerInvoice],
            children: {},
          },
          [EDomainClass.MissionInvoice]: {
            className: EDomainClass.MissionInvoice,
            classNames: [EDomainClass.MissionInvoice],
            children: {},
          },
        },
      },
      [EDomainClass.Payment]: {
        className: EDomainClass.Payment,
        classNames: [
          EDomainClass.Payment,
          EDomainClass.BankAccountPayment,
          EDomainClass.CashPayment,
          EDomainClass.CreditCardPayment,
          EDomainClass.ExactPayment,
          EDomainClass.ExactSettlementPayment,
          EDomainClass.IntermediaryAgencyPayment,
          EDomainClass.InternalPayment,
          EDomainClass.PersonalExpenseMonthlyStatementPayment,
          EDomainClass.PersonalExpensePayment,
        ],
        children: {
          [EDomainClass.BankAccountPayment]: {
            className: EDomainClass.BankAccountPayment,
            classNames: [EDomainClass.BankAccountPayment],
            children: {},
          },
          [EDomainClass.CashPayment]: {
            className: EDomainClass.CashPayment,
            classNames: [EDomainClass.CashPayment],
            children: {},
          },
          [EDomainClass.CreditCardPayment]: {
            className: EDomainClass.CreditCardPayment,
            classNames: [EDomainClass.CreditCardPayment],
            children: {},
          },
          [EDomainClass.ExactPayment]: {
            className: EDomainClass.ExactPayment,
            classNames: [EDomainClass.ExactPayment],
            children: {},
          },
          [EDomainClass.ExactSettlementPayment]: {
            className: EDomainClass.ExactSettlementPayment,
            classNames: [EDomainClass.ExactSettlementPayment],
            children: {},
          },
          [EDomainClass.IntermediaryAgencyPayment]: {
            className: EDomainClass.IntermediaryAgencyPayment,
            classNames: [EDomainClass.IntermediaryAgencyPayment],
            children: {},
          },
          [EDomainClass.InternalPayment]: {
            className: EDomainClass.InternalPayment,
            classNames: [EDomainClass.InternalPayment],
            children: {},
          },
          [EDomainClass.PersonalExpenseMonthlyStatementPayment]: {
            className: EDomainClass.PersonalExpenseMonthlyStatementPayment,
            classNames: [EDomainClass.PersonalExpenseMonthlyStatementPayment],
            children: {},
          },
          [EDomainClass.PersonalExpensePayment]: {
            className: EDomainClass.PersonalExpensePayment,
            classNames: [EDomainClass.PersonalExpensePayment],
            children: {},
          },
        },
      },
    },
  },
  [EDomainClass.AccountMouvementPayment]: {
    className: EDomainClass.AccountMouvementPayment,
    classNames: [EDomainClass.AccountMouvementPayment],
    children: {},
  },
  [EDomainClass.InvoiceItem]: {
    className: EDomainClass.InvoiceItem,
    classNames: [
      EDomainClass.InvoiceItem,
      EDomainClass.AircraftOwnerInvoiceItem,
      EDomainClass.FixedFeeShareCreditInvoiceItem,
      EDomainClass.FixedFeeShareInvoiceItem,
      EDomainClass.MissionInvoiceItem,
      EDomainClass.MonthlyFeeDeductionDepositInvoiceItem,
      EDomainClass.MonthlyFeeDepositInvoiceItem,
      EDomainClass.StopRegularizationInvoiceItem,
    ],
    children: {
      [EDomainClass.AircraftOwnerInvoiceItem]: {
        className: EDomainClass.AircraftOwnerInvoiceItem,
        classNames: [EDomainClass.AircraftOwnerInvoiceItem],
        children: {},
      },
      [EDomainClass.FixedFeeShareCreditInvoiceItem]: {
        className: EDomainClass.FixedFeeShareCreditInvoiceItem,
        classNames: [EDomainClass.FixedFeeShareCreditInvoiceItem],
        children: {},
      },
      [EDomainClass.FixedFeeShareInvoiceItem]: {
        className: EDomainClass.FixedFeeShareInvoiceItem,
        classNames: [EDomainClass.FixedFeeShareInvoiceItem],
        children: {},
      },
      [EDomainClass.MissionInvoiceItem]: {
        className: EDomainClass.MissionInvoiceItem,
        classNames: [EDomainClass.MissionInvoiceItem],
        children: {},
      },
      [EDomainClass.MonthlyFeeDeductionDepositInvoiceItem]: {
        className: EDomainClass.MonthlyFeeDeductionDepositInvoiceItem,
        classNames: [EDomainClass.MonthlyFeeDeductionDepositInvoiceItem],
        children: {},
      },
      [EDomainClass.MonthlyFeeDepositInvoiceItem]: {
        className: EDomainClass.MonthlyFeeDepositInvoiceItem,
        classNames: [EDomainClass.MonthlyFeeDepositInvoiceItem],
        children: {},
      },
      [EDomainClass.StopRegularizationInvoiceItem]: {
        className: EDomainClass.StopRegularizationInvoiceItem,
        classNames: [EDomainClass.StopRegularizationInvoiceItem],
        children: {},
      },
    },
  },
  [EDomainClass.CountryInternalFlightVATRate]: {
    className: EDomainClass.CountryInternalFlightVATRate,
    classNames: [EDomainClass.CountryInternalFlightVATRate],
    children: {},
  },
  [EDomainClass.DayMissionInvoiceItem]: {
    className: EDomainClass.DayMissionInvoiceItem,
    classNames: [EDomainClass.DayMissionInvoiceItem],
    children: {},
  },
  [EDomainClass.FlightMissionInvoiceItem]: {
    className: EDomainClass.FlightMissionInvoiceItem,
    classNames: [EDomainClass.FlightMissionInvoiceItem],
    children: {},
  },
  [EDomainClass.FlightRefuelingDistribution]: {
    className: EDomainClass.FlightRefuelingDistribution,
    classNames: [EDomainClass.FlightRefuelingDistribution],
    children: {},
  },
  [EDomainClass.FuelConsumptionDistribution]: {
    className: EDomainClass.FuelConsumptionDistribution,
    classNames: [EDomainClass.FuelConsumptionDistribution],
    children: {},
  },
  [EDomainClass.FuelCostReference]: {
    className: EDomainClass.FuelCostReference,
    classNames: [EDomainClass.FuelCostReference],
    children: {},
  },
  [EDomainClass.FuelDifferenceComputationDetail]: {
    className: EDomainClass.FuelDifferenceComputationDetail,
    classNames: [EDomainClass.FuelDifferenceComputationDetail],
    children: {},
  },
  [EDomainClass.InvoiceCustomerTransfer]: {
    className: EDomainClass.InvoiceCustomerTransfer,
    classNames: [EDomainClass.InvoiceCustomerTransfer],
    children: {},
  },
  [EDomainClass.Loan]: {
    className: EDomainClass.Loan,
    classNames: [EDomainClass.Loan],
    children: {},
  },
  [EDomainClass.MembershipSubscriptionAircraftMonthlyFee]: {
    className: EDomainClass.MembershipSubscriptionAircraftMonthlyFee,
    classNames: [EDomainClass.MembershipSubscriptionAircraftMonthlyFee],
    children: {},
  },
  [EDomainClass.MissionBillingInstruction]: {
    className: EDomainClass.MissionBillingInstruction,
    classNames: [EDomainClass.MissionBillingInstruction],
    children: {},
  },
  [EDomainClass.MissionDepositDetail]: {
    className: EDomainClass.MissionDepositDetail,
    classNames: [EDomainClass.MissionDepositDetail],
    children: {},
  },
  [EDomainClass.PaymentCondition]: {
    className: EDomainClass.PaymentCondition,
    classNames: [EDomainClass.PaymentCondition],
    children: {},
  },
  [EDomainClass.StopRegularizationDetail]: {
    className: EDomainClass.StopRegularizationDetail,
    classNames: [EDomainClass.StopRegularizationDetail],
    children: {},
  },
  [EDomainClass.InvoiceDispute]: {
    className: EDomainClass.InvoiceDispute,
    classNames: [EDomainClass.InvoiceDispute],
    children: {},
  },
  [EDomainClass.InvoiceDisputeSettings]: {
    className: EDomainClass.InvoiceDisputeSettings,
    classNames: [EDomainClass.InvoiceDisputeSettings],
    children: {},
  },
  [EDomainClass.InvoiceDisputeTransition]: {
    className: EDomainClass.InvoiceDisputeTransition,
    classNames: [EDomainClass.InvoiceDisputeTransition],
    children: {},
  },
  [EDomainClass.AirportInvoiceRule]: {
    className: EDomainClass.AirportInvoiceRule,
    classNames: [EDomainClass.AirportInvoiceRule],
    children: {},
  },
  [EDomainClass.ExpectedInvoiceWaiver]: {
    className: EDomainClass.ExpectedInvoiceWaiver,
    classNames: [EDomainClass.ExpectedInvoiceWaiver],
    children: {},
  },
  [EDomainClass.SupplierInvoiceProvision]: {
    className: EDomainClass.SupplierInvoiceProvision,
    classNames: [EDomainClass.SupplierInvoiceProvision],
    children: {},
  },
  [EDomainClass.PaymentReminder]: {
    className: EDomainClass.PaymentReminder,
    classNames: [EDomainClass.PaymentReminder],
    children: {},
  },
  [EDomainClass.PaymentReminderItem]: {
    className: EDomainClass.PaymentReminderItem,
    classNames: [EDomainClass.PaymentReminderItem],
    children: {},
  },
  [EDomainClass.PaymentReminderSettings]: {
    className: EDomainClass.PaymentReminderSettings,
    classNames: [EDomainClass.PaymentReminderSettings],
    children: {},
  },
  [EDomainClass.AccountingChartsAccount]: {
    className: EDomainClass.AccountingChartsAccount,
    classNames: [EDomainClass.AccountingChartsAccount],
    children: {},
  },
  [EDomainClass.AipSnapshot]: {
    className: EDomainClass.AipSnapshot,
    classNames: [EDomainClass.AipSnapshot],
    children: {},
  },
  [EDomainClass.CrewAnalyticsAverage]: {
    className: EDomainClass.CrewAnalyticsAverage,
    classNames: [EDomainClass.CrewAnalyticsAverage],
    children: {},
  },
  [EDomainClass.CrewAnalyticsCategory]: {
    className: EDomainClass.CrewAnalyticsCategory,
    classNames: [EDomainClass.CrewAnalyticsCategory],
    children: {},
  },
  [EDomainClass.DutyAnalytics]: {
    className: EDomainClass.DutyAnalytics,
    classNames: [
      EDomainClass.DutyAnalytics,
      EDomainClass.CategoryDutyAnalytics,
      EDomainClass.CrewDutyAnalytics,
    ],
    children: {
      [EDomainClass.CategoryDutyAnalytics]: {
        className: EDomainClass.CategoryDutyAnalytics,
        classNames: [EDomainClass.CategoryDutyAnalytics],
        children: {},
      },
      [EDomainClass.CrewDutyAnalytics]: {
        className: EDomainClass.CrewDutyAnalytics,
        classNames: [EDomainClass.CrewDutyAnalytics],
        children: {},
      },
    },
  },
  [EDomainClass.DutyAnalyticsCategory]: {
    className: EDomainClass.DutyAnalyticsCategory,
    classNames: [EDomainClass.DutyAnalyticsCategory],
    children: {},
  },
  [EDomainClass.AssetResource]: {
    className: EDomainClass.AssetResource,
    classNames: [
      EDomainClass.AssetResource,
      EDomainClass.CarResource,
      EDomainClass.FuelCardResource,
      EDomainClass.ITResource,
      EDomainClass.SIMCardResource,
    ],
    children: {
      [EDomainClass.CarResource]: {
        className: EDomainClass.CarResource,
        classNames: [EDomainClass.CarResource],
        children: {},
      },
      [EDomainClass.FuelCardResource]: {
        className: EDomainClass.FuelCardResource,
        classNames: [EDomainClass.FuelCardResource],
        children: {},
      },
      [EDomainClass.ITResource]: {
        className: EDomainClass.ITResource,
        classNames: [EDomainClass.ITResource],
        children: {},
      },
      [EDomainClass.SIMCardResource]: {
        className: EDomainClass.SIMCardResource,
        classNames: [EDomainClass.SIMCardResource],
        children: {},
      },
    },
  },
  [EDomainClass.AssetResourceAssignment]: {
    className: EDomainClass.AssetResourceAssignment,
    classNames: [EDomainClass.AssetResourceAssignment, EDomainClass.CarResourceAssignment],
    children: {
      [EDomainClass.CarResourceAssignment]: {
        className: EDomainClass.CarResourceAssignment,
        classNames: [EDomainClass.CarResourceAssignment],
        children: {},
      },
    },
  },
  [EDomainClass.AssetResourceRemark]: {
    className: EDomainClass.AssetResourceRemark,
    classNames: [EDomainClass.AssetResourceRemark],
    children: {},
  },
  [EDomainClass.CarOdometerReport]: {
    className: EDomainClass.CarOdometerReport,
    classNames: [EDomainClass.CarOdometerReport],
    children: {},
  },
  [EDomainClass.CarTripReport]: {
    className: EDomainClass.CarTripReport,
    classNames: [EDomainClass.CarTripReport],
    children: {},
  },
  [EDomainClass.ImpersonationAuditLog]: {
    className: EDomainClass.ImpersonationAuditLog,
    classNames: [EDomainClass.ImpersonationAuditLog],
    children: {},
  },
  [EDomainClass.PinCodeLockout]: {
    className: EDomainClass.PinCodeLockout,
    classNames: [EDomainClass.PinCodeLockout],
    children: {},
  },
  [EDomainClass.UserInvitation]: {
    className: EDomainClass.UserInvitation,
    classNames: [EDomainClass.UserInvitation],
    children: {},
  },
  [EDomainClass.UserInvitationLinkedShareholder]: {
    className: EDomainClass.UserInvitationLinkedShareholder,
    classNames: [EDomainClass.UserInvitationLinkedShareholder],
    children: {},
  },
  [EDomainClass.UserInvitationRole]: {
    className: EDomainClass.UserInvitationRole,
    classNames: [EDomainClass.UserInvitationRole],
    children: {},
  },
  [EDomainClass.UserSignupRequest]: {
    className: EDomainClass.UserSignupRequest,
    classNames: [EDomainClass.UserSignupRequest],
    children: {},
  },
  [EDomainClass.UserSignupRequestLinkedShareholder]: {
    className: EDomainClass.UserSignupRequestLinkedShareholder,
    classNames: [EDomainClass.UserSignupRequestLinkedShareholder],
    children: {},
  },
  [EDomainClass.CrewDailyRevenue]: {
    className: EDomainClass.CrewDailyRevenue,
    classNames: [EDomainClass.CrewDailyRevenue],
    children: {},
  },
  [EDomainClass.CrewMonthlyStatement]: {
    className: EDomainClass.CrewMonthlyStatement,
    classNames: [EDomainClass.CrewMonthlyStatement],
    children: {},
  },
  [EDomainClass.DispatchAlertDismissal]: {
    className: EDomainClass.DispatchAlertDismissal,
    classNames: [EDomainClass.DispatchAlertDismissal],
    children: {},
  },
  [EDomainClass.DispatchMemberNote]: {
    className: EDomainClass.DispatchMemberNote,
    classNames: [EDomainClass.DispatchMemberNote],
    children: {},
  },
  [EDomainClass.FlightServiceStatus]: {
    className: EDomainClass.FlightServiceStatus,
    classNames: [EDomainClass.FlightServiceStatus],
    children: {},
  },
  [EDomainClass.QuickReplyTemplate]: {
    className: EDomainClass.QuickReplyTemplate,
    classNames: [EDomainClass.QuickReplyTemplate],
    children: {},
  },
  [EDomainClass.ServiceProvider]: {
    className: EDomainClass.ServiceProvider,
    classNames: [EDomainClass.ServiceProvider],
    children: {},
  },
  [EDomainClass.ServiceRequest]: {
    className: EDomainClass.ServiceRequest,
    classNames: [EDomainClass.ServiceRequest],
    children: {},
  },
  [EDomainClass.ServiceRequestDocument]: {
    className: EDomainClass.ServiceRequestDocument,
    classNames: [EDomainClass.ServiceRequestDocument],
    children: {},
  },
  [EDomainClass.ServiceRequestLog]: {
    className: EDomainClass.ServiceRequestLog,
    classNames: [EDomainClass.ServiceRequestLog],
    children: {},
  },
  [EDomainClass.ServiceRequestOutbox]: {
    className: EDomainClass.ServiceRequestOutbox,
    classNames: [EDomainClass.ServiceRequestOutbox],
    children: {},
  },
  [EDomainClass.ServiceRequestPerson]: {
    className: EDomainClass.ServiceRequestPerson,
    classNames: [EDomainClass.ServiceRequestPerson],
    children: {},
  },
  [EDomainClass.ServiceType]: {
    className: EDomainClass.ServiceType,
    classNames: [EDomainClass.ServiceType],
    children: {},
  },
  [EDomainClass.PassengerBriefing]: {
    className: EDomainClass.PassengerBriefing,
    classNames: [EDomainClass.PassengerBriefing],
    children: {},
  },
  [EDomainClass.FlightChecklist]: {
    className: EDomainClass.FlightChecklist,
    classNames: [EDomainClass.FlightChecklist],
    children: {},
  },
  [EDomainClass.FlightChecklistItem]: {
    className: EDomainClass.FlightChecklistItem,
    classNames: [EDomainClass.FlightChecklistItem],
    children: {},
  },
  [EDomainClass.FlightChecklistItemTodo]: {
    className: EDomainClass.FlightChecklistItemTodo,
    classNames: [EDomainClass.FlightChecklistItemTodo],
    children: {},
  },
  [EDomainClass.OpsChecklistTemplate]: {
    className: EDomainClass.OpsChecklistTemplate,
    classNames: [EDomainClass.OpsChecklistTemplate],
    children: {},
  },
  [EDomainClass.OpsChecklistTemplateItem]: {
    className: EDomainClass.OpsChecklistTemplateItem,
    classNames: [EDomainClass.OpsChecklistTemplateItem],
    children: {},
  },
  [EDomainClass.CrewRequest]: {
    className: EDomainClass.CrewRequest,
    classNames: [EDomainClass.CrewRequest],
    children: {},
  },
  [EDomainClass.CrewRequestAlias]: {
    className: EDomainClass.CrewRequestAlias,
    classNames: [EDomainClass.CrewRequestAlias],
    children: {},
  },
  [EDomainClass.EburyBatch]: {
    className: EDomainClass.EburyBatch,
    classNames: [EDomainClass.EburyBatch],
    children: {},
  },
  [EDomainClass.EburyBatchLine]: {
    className: EDomainClass.EburyBatchLine,
    classNames: [EDomainClass.EburyBatchLine],
    children: {},
  },
  [EDomainClass.EburyLoginBlock]: {
    className: EDomainClass.EburyLoginBlock,
    classNames: [EDomainClass.EburyLoginBlock],
    children: {},
  },
  [EDomainClass.EburyPayment]: {
    className: EDomainClass.EburyPayment,
    classNames: [EDomainClass.EburyPayment],
    children: {},
  },
  [EDomainClass.EburyTrade]: {
    className: EDomainClass.EburyTrade,
    classNames: [EDomainClass.EburyTrade],
    children: {},
  },
  [EDomainClass.ExactJournalStatus]: {
    className: EDomainClass.ExactJournalStatus,
    classNames: [EDomainClass.ExactJournalStatus],
    children: {},
  },
  [EDomainClass.ExactSync]: {
    className: EDomainClass.ExactSync,
    classNames: [EDomainClass.ExactSync],
    children: {},
  },
  [EDomainClass.ExactSyncQueue]: {
    className: EDomainClass.ExactSyncQueue,
    classNames: [EDomainClass.ExactSyncQueue],
    children: {},
  },
  [EDomainClass.ExactVATCode]: {
    className: EDomainClass.ExactVATCode,
    classNames: [EDomainClass.ExactVATCode],
    children: {},
  },
  [EDomainClass.UserExactToken]: {
    className: EDomainClass.UserExactToken,
    classNames: [EDomainClass.UserExactToken],
    children: {},
  },
  [EDomainClass.ExactVATCodeExactLink]: {
    className: EDomainClass.ExactVATCodeExactLink,
    classNames: [EDomainClass.ExactVATCodeExactLink],
    children: {},
  },
  [EDomainClass.ExpenseCategoryExactLink]: {
    className: EDomainClass.ExpenseCategoryExactLink,
    classNames: [EDomainClass.ExpenseCategoryExactLink],
    children: {},
  },
  [EDomainClass.ExpenseItemExactLink]: {
    className: EDomainClass.ExpenseItemExactLink,
    classNames: [EDomainClass.ExpenseItemExactLink],
    children: {},
  },
  [EDomainClass.FiscalDocumentExactLink]: {
    className: EDomainClass.FiscalDocumentExactLink,
    classNames: [EDomainClass.FiscalDocumentExactLink],
    children: {},
  },
  [EDomainClass.InvoiceItemExactLink]: {
    className: EDomainClass.InvoiceItemExactLink,
    classNames: [EDomainClass.InvoiceItemExactLink],
    children: {},
  },
  [EDomainClass.PersonalFile]: {
    className: EDomainClass.PersonalFile,
    classNames: [EDomainClass.PersonalFile],
    children: {},
  },
  [EDomainClass.PersonalFileDownload]: {
    className: EDomainClass.PersonalFileDownload,
    classNames: [EDomainClass.PersonalFileDownload],
    children: {},
  },
  [EDomainClass.PersonalFileLink]: {
    className: EDomainClass.PersonalFileLink,
    classNames: [EDomainClass.PersonalFileLink],
    children: {},
  },
  [EDomainClass.AirportProvider]: {
    className: EDomainClass.AirportProvider,
    classNames: [EDomainClass.AirportProvider, EDomainClass.Hotel],
    children: {
      [EDomainClass.Hotel]: {
        className: EDomainClass.Hotel,
        classNames: [EDomainClass.Hotel],
        children: {},
      },
    },
  },
  [EDomainClass.AirportProviderLink]: {
    className: EDomainClass.AirportProviderLink,
    classNames: [EDomainClass.AirportProviderLink],
    children: {},
  },
  [EDomainClass.CharleroiMovement]: {
    className: EDomainClass.CharleroiMovement,
    classNames: [EDomainClass.CharleroiMovement],
    children: {},
  },
  [EDomainClass.DeclarationAlertStatus]: {
    className: EDomainClass.DeclarationAlertStatus,
    classNames: [EDomainClass.DeclarationAlertStatus],
    children: {},
  },
  [EDomainClass.FriendlyWebRecord]: {
    className: EDomainClass.FriendlyWebRecord,
    classNames: [EDomainClass.FriendlyWebRecord],
    children: {},
  },
  [EDomainClass.GeneralDeclarationBelgiumLog]: {
    className: EDomainClass.GeneralDeclarationBelgiumLog,
    classNames: [EDomainClass.GeneralDeclarationBelgiumLog],
    children: {},
  },
  [EDomainClass.GeneralDeclarationSnapshot]: {
    className: EDomainClass.GeneralDeclarationSnapshot,
    classNames: [EDomainClass.GeneralDeclarationSnapshot],
    children: {},
  },
  [EDomainClass.MissionPositioning]: {
    className: EDomainClass.MissionPositioning,
    classNames: [EDomainClass.MissionPositioning],
    children: {},
  },
  [EDomainClass.Passenger]: {
    className: EDomainClass.Passenger,
    classNames: [EDomainClass.Passenger],
    children: {},
  },
  [EDomainClass.PassengerAssignment]: {
    className: EDomainClass.PassengerAssignment,
    classNames: [EDomainClass.PassengerAssignment],
    children: {},
  },
  [EDomainClass.PassengerGroup]: {
    className: EDomainClass.PassengerGroup,
    classNames: [EDomainClass.PassengerGroup],
    children: {},
  },
  [EDomainClass.PassengerSklAlias]: {
    className: EDomainClass.PassengerSklAlias,
    classNames: [EDomainClass.PassengerSklAlias],
    children: {},
  },
  [EDomainClass.PassengerTravelDocument]: {
    className: EDomainClass.PassengerTravelDocument,
    classNames: [EDomainClass.PassengerTravelDocument],
    children: {},
  },
  [EDomainClass.SkylegsFlightDocument]: {
    className: EDomainClass.SkylegsFlightDocument,
    classNames: [EDomainClass.SkylegsFlightDocument],
    children: {},
  },
  [EDomainClass.SkylegsFlightService]: {
    className: EDomainClass.SkylegsFlightService,
    classNames: [EDomainClass.SkylegsFlightService],
    children: {},
  },
  [EDomainClass.TravelDocumentScan]: {
    className: EDomainClass.TravelDocumentScan,
    classNames: [EDomainClass.TravelDocumentScan],
    children: {},
  },
  [EDomainClass.FlightOfpLink]: {
    className: EDomainClass.FlightOfpLink,
    classNames: [EDomainClass.FlightOfpLink],
    children: {},
  },
  [EDomainClass.PFFFlight]: {
    className: EDomainClass.PFFFlight,
    classNames: [EDomainClass.PFFFlight],
    children: {},
  },
  [EDomainClass.PreflightOfp]: {
    className: EDomainClass.PreflightOfp,
    classNames: [EDomainClass.PreflightOfp],
    children: {},
  },
  [EDomainClass.FuelPriceEntry]: {
    className: EDomainClass.FuelPriceEntry,
    classNames: [EDomainClass.FuelPriceEntry],
    children: {},
  },
  [EDomainClass.FuelPriceImport]: {
    className: EDomainClass.FuelPriceImport,
    classNames: [EDomainClass.FuelPriceImport],
    children: {},
  },
  [EDomainClass.HotelBooking]: {
    className: EDomainClass.HotelBooking,
    classNames: [EDomainClass.HotelBooking],
    children: {},
  },
  [EDomainClass.HotelBookingAssignment]: {
    className: EDomainClass.HotelBookingAssignment,
    classNames: [EDomainClass.HotelBookingAssignment],
    children: {},
  },
  [EDomainClass.HotelBookingMean]: {
    className: EDomainClass.HotelBookingMean,
    classNames: [
      EDomainClass.HotelBookingMean,
      EDomainClass.HotelBookingMeanMail,
      EDomainClass.HotelBookingMeanThirdParty,
      EDomainClass.HotelBookingMeanWebsite,
    ],
    children: {
      [EDomainClass.HotelBookingMeanMail]: {
        className: EDomainClass.HotelBookingMeanMail,
        classNames: [EDomainClass.HotelBookingMeanMail],
        children: {},
      },
      [EDomainClass.HotelBookingMeanThirdParty]: {
        className: EDomainClass.HotelBookingMeanThirdParty,
        classNames: [EDomainClass.HotelBookingMeanThirdParty],
        children: {},
      },
      [EDomainClass.HotelBookingMeanWebsite]: {
        className: EDomainClass.HotelBookingMeanWebsite,
        classNames: [EDomainClass.HotelBookingMeanWebsite],
        children: {},
      },
    },
  },
  [EDomainClass.HotelRating]: {
    className: EDomainClass.HotelRating,
    classNames: [EDomainClass.HotelRating],
    children: {},
  },
  [EDomainClass.AssetAcquisitionAgreement]: {
    className: EDomainClass.AssetAcquisitionAgreement,
    classNames: [EDomainClass.AssetAcquisitionAgreement],
    children: {},
  },
  [EDomainClass.AssetAcquisitionAgreementItem]: {
    className: EDomainClass.AssetAcquisitionAgreementItem,
    classNames: [EDomainClass.AssetAcquisitionAgreementItem],
    children: {},
  },
  [EDomainClass.AssetAcquisitionAgreementTerms]: {
    className: EDomainClass.AssetAcquisitionAgreementTerms,
    classNames: [EDomainClass.AssetAcquisitionAgreementTerms],
    children: {},
  },
  [EDomainClass.AssetAcquisitionDeductionLine]: {
    className: EDomainClass.AssetAcquisitionDeductionLine,
    classNames: [EDomainClass.AssetAcquisitionDeductionLine],
    children: {},
  },
  [EDomainClass.CrewWageCar]: {
    className: EDomainClass.CrewWageCar,
    classNames: [EDomainClass.CrewWageCar],
    children: {},
  },
  [EDomainClass.CrewWageCarAssignment]: {
    className: EDomainClass.CrewWageCarAssignment,
    classNames: [EDomainClass.CrewWageCarAssignment],
    children: {},
  },
  [EDomainClass.CrewWageCarDistributedCost]: {
    className: EDomainClass.CrewWageCarDistributedCost,
    classNames: [EDomainClass.CrewWageCarDistributedCost],
    children: {},
  },
  [EDomainClass.CrewWageCarManualCost]: {
    className: EDomainClass.CrewWageCarManualCost,
    classNames: [EDomainClass.CrewWageCarManualCost],
    children: {},
  },
  [EDomainClass.EmploymentContract]: {
    className: EDomainClass.EmploymentContract,
    classNames: [EDomainClass.EmploymentContract],
    children: {},
  },
  [EDomainClass.EmploymentContractAmendment]: {
    className: EDomainClass.EmploymentContractAmendment,
    classNames: [EDomainClass.EmploymentContractAmendment],
    children: {},
  },
  [EDomainClass.LeaveAssignment]: {
    className: EDomainClass.LeaveAssignment,
    classNames: [EDomainClass.LeaveAssignment],
    children: {},
  },
  [EDomainClass.LeaveAssignmentRequest]: {
    className: EDomainClass.LeaveAssignmentRequest,
    classNames: [EDomainClass.LeaveAssignmentRequest],
    children: {},
  },
  [EDomainClass.LeaveAssignmentTemplate]: {
    className: EDomainClass.LeaveAssignmentTemplate,
    classNames: [EDomainClass.LeaveAssignmentTemplate],
    children: {},
  },
  [EDomainClass.LeaveRequest]: {
    className: EDomainClass.LeaveRequest,
    classNames: [EDomainClass.LeaveRequest, EDomainClass.PublicHolidayLeave],
    children: {
      [EDomainClass.PublicHolidayLeave]: {
        className: EDomainClass.PublicHolidayLeave,
        classNames: [EDomainClass.PublicHolidayLeave],
        children: {},
      },
    },
  },
  [EDomainClass.LeaveRequestDay]: {
    className: EDomainClass.LeaveRequestDay,
    classNames: [EDomainClass.LeaveRequestDay],
    children: {},
  },
  [EDomainClass.LeaveType]: {
    className: EDomainClass.LeaveType,
    classNames: [EDomainClass.LeaveType],
    children: {},
  },
  [EDomainClass.PublicHoliday]: {
    className: EDomainClass.PublicHoliday,
    classNames: [EDomainClass.PublicHoliday],
    children: {},
  },
  [EDomainClass.RosterAggregate]: {
    className: EDomainClass.RosterAggregate,
    classNames: [EDomainClass.RosterAggregate],
    children: {},
  },
  [EDomainClass.RosterCategory]: {
    className: EDomainClass.RosterCategory,
    classNames: [EDomainClass.RosterCategory],
    children: {},
  },
  [EDomainClass.RosterCategoryWarning]: {
    className: EDomainClass.RosterCategoryWarning,
    classNames: [EDomainClass.RosterCategoryWarning],
    children: {},
  },
  [EDomainClass.RosterDay]: {
    className: EDomainClass.RosterDay,
    classNames: [EDomainClass.RosterDay],
    children: {},
  },
  [EDomainClass.RosterUserAgenda]: {
    className: EDomainClass.RosterUserAgenda,
    classNames: [
      EDomainClass.RosterUserAgenda,
      EDomainClass.RosterLeaveUserAgenda,
      EDomainClass.RosterTemplateUserAgenda,
      EDomainClass.RosterChangeUserAgenda,
    ],
    children: {
      [EDomainClass.RosterLeaveUserAgenda]: {
        className: EDomainClass.RosterLeaveUserAgenda,
        classNames: [EDomainClass.RosterLeaveUserAgenda],
        children: {},
      },
      [EDomainClass.RosterTemplateUserAgenda]: {
        className: EDomainClass.RosterTemplateUserAgenda,
        classNames: [EDomainClass.RosterTemplateUserAgenda, EDomainClass.RosterChangeUserAgenda],
        children: {
          [EDomainClass.RosterChangeUserAgenda]: {
            className: EDomainClass.RosterChangeUserAgenda,
            classNames: [EDomainClass.RosterChangeUserAgenda],
            children: {},
          },
        },
      },
    },
  },
  [EDomainClass.RosterManualChangeAction]: {
    className: EDomainClass.RosterManualChangeAction,
    classNames: [EDomainClass.RosterManualChangeAction],
    children: {},
  },
  [EDomainClass.RosterMonthlyStatistic]: {
    className: EDomainClass.RosterMonthlyStatistic,
    classNames: [EDomainClass.RosterMonthlyStatistic],
    children: {},
  },
  [EDomainClass.RosterTemplate]: {
    className: EDomainClass.RosterTemplate,
    classNames: [EDomainClass.RosterTemplate],
    children: {},
  },
  [EDomainClass.RosterTemplateAssignment]: {
    className: EDomainClass.RosterTemplateAssignment,
    classNames: [EDomainClass.RosterTemplateAssignment],
    children: {},
  },
  [EDomainClass.RosterTemplateDayPosition]: {
    className: EDomainClass.RosterTemplateDayPosition,
    classNames: [EDomainClass.RosterTemplateDayPosition],
    children: {},
  },
  [EDomainClass.RosterVolunteerDay]: {
    className: EDomainClass.RosterVolunteerDay,
    classNames: [EDomainClass.RosterVolunteerDay],
    children: {},
  },
  [EDomainClass.VolunteerCall]: {
    className: EDomainClass.VolunteerCall,
    classNames: [EDomainClass.VolunteerCall],
    children: {},
  },
  [EDomainClass.VolunteerCallDay]: {
    className: EDomainClass.VolunteerCallDay,
    classNames: [EDomainClass.VolunteerCallDay],
    children: {},
  },
  [EDomainClass.VolunteerCallInvitation]: {
    className: EDomainClass.VolunteerCallInvitation,
    classNames: [EDomainClass.VolunteerCallInvitation],
    children: {},
  },
  [EDomainClass.VolunteerCallInvitationDay]: {
    className: EDomainClass.VolunteerCallInvitationDay,
    classNames: [EDomainClass.VolunteerCallInvitationDay],
    children: {},
  },
  [EDomainClass.VolunteerWeeklyReport]: {
    className: EDomainClass.VolunteerWeeklyReport,
    classNames: [EDomainClass.VolunteerWeeklyReport],
    children: {},
  },
  [EDomainClass.AircraftTypeCrewRate]: {
    className: EDomainClass.AircraftTypeCrewRate,
    classNames: [EDomainClass.AircraftTypeCrewRate],
    children: {},
  },
  [EDomainClass.CrewAssignment]: {
    className: EDomainClass.CrewAssignment,
    classNames: [EDomainClass.CrewAssignment],
    children: {},
  },
  [EDomainClass.CrewCategory]: {
    className: EDomainClass.CrewCategory,
    classNames: [EDomainClass.CrewCategory],
    children: {},
  },
  [EDomainClass.CrewCategoryRate]: {
    className: EDomainClass.CrewCategoryRate,
    classNames: [EDomainClass.CrewCategoryRate],
    children: {},
  },
  [EDomainClass.CrewRate]: {
    className: EDomainClass.CrewRate,
    classNames: [EDomainClass.CrewRate],
    children: {},
  },
  [EDomainClass.CrewType]: {
    className: EDomainClass.CrewType,
    classNames: [EDomainClass.CrewType],
    children: {},
  },
  [EDomainClass.CrewWage]: {
    className: EDomainClass.CrewWage,
    classNames: [EDomainClass.CrewWage],
    children: {},
  },
  [EDomainClass.Indexation]: {
    className: EDomainClass.Indexation,
    classNames: [EDomainClass.Indexation],
    children: {},
  },
  [EDomainClass.OffDayPremiumLine]: {
    className: EDomainClass.OffDayPremiumLine,
    classNames: [EDomainClass.OffDayPremiumLine],
    children: {},
  },
  [EDomainClass.MemberQuotaAlert]: {
    className: EDomainClass.MemberQuotaAlert,
    classNames: [EDomainClass.MemberQuotaAlert],
    children: {},
  },
  [EDomainClass.MemberQuotaSettings]: {
    className: EDomainClass.MemberQuotaSettings,
    classNames: [EDomainClass.MemberQuotaSettings],
    children: {},
  },
  [EDomainClass.LegalTermsVersion]: {
    className: EDomainClass.LegalTermsVersion,
    classNames: [EDomainClass.LegalTermsVersion],
    children: {},
  },
  [EDomainClass.MailboxAccount]: {
    className: EDomainClass.MailboxAccount,
    classNames: [EDomainClass.MailboxAccount],
    children: {},
  },
  [EDomainClass.Campaign]: {
    className: EDomainClass.Campaign,
    classNames: [EDomainClass.Campaign],
    children: {},
  },
  [EDomainClass.CampaignContent]: {
    className: EDomainClass.CampaignContent,
    classNames: [EDomainClass.CampaignContent],
    children: {},
  },
  [EDomainClass.CampaignCriteria]: {
    className: EDomainClass.CampaignCriteria,
    classNames: [EDomainClass.CampaignCriteria],
    children: {},
  },
  [EDomainClass.CampaignFile]: {
    className: EDomainClass.CampaignFile,
    classNames: [EDomainClass.CampaignFile],
    children: {},
  },
  [EDomainClass.CampaignFolder]: {
    className: EDomainClass.CampaignFolder,
    classNames: [EDomainClass.CampaignFolder],
    children: {},
  },
  [EDomainClass.CampaignLink]: {
    className: EDomainClass.CampaignLink,
    classNames: [EDomainClass.CampaignLink],
    children: {},
  },
  [EDomainClass.CampaignRecipient]: {
    className: EDomainClass.CampaignRecipient,
    classNames: [EDomainClass.CampaignRecipient],
    children: {},
  },
  [EDomainClass.CampaignRecipientEvent]: {
    className: EDomainClass.CampaignRecipientEvent,
    classNames: [EDomainClass.CampaignRecipientEvent],
    children: {},
  },
  [EDomainClass.EmailRecipient]: {
    className: EDomainClass.EmailRecipient,
    classNames: [EDomainClass.EmailRecipient],
    children: {},
  },
  [EDomainClass.MailSenderIdentity]: {
    className: EDomainClass.MailSenderIdentity,
    classNames: [EDomainClass.MailSenderIdentity],
    children: {},
  },
  [EDomainClass.MailSuppression]: {
    className: EDomainClass.MailSuppression,
    classNames: [EDomainClass.MailSuppression],
    children: {},
  },
  [EDomainClass.MemberCommunicationPreference]: {
    className: EDomainClass.MemberCommunicationPreference,
    classNames: [EDomainClass.MemberCommunicationPreference],
    children: {},
  },
  [EDomainClass.PublishedMailingImage]: {
    className: EDomainClass.PublishedMailingImage,
    classNames: [EDomainClass.PublishedMailingImage],
    children: {},
  },
  [EDomainClass.MdmAuditLog]: {
    className: EDomainClass.MdmAuditLog,
    classNames: [EDomainClass.MdmAuditLog],
    children: {},
  },
  [EDomainClass.MediaAsset]: {
    className: EDomainClass.MediaAsset,
    classNames: [EDomainClass.MediaAsset],
    children: {},
  },
  [EDomainClass.MediaFolder]: {
    className: EDomainClass.MediaFolder,
    classNames: [EDomainClass.MediaFolder],
    children: {},
  },
  [EDomainClass.MonthlyStatement]: {
    className: EDomainClass.MonthlyStatement,
    classNames: [
      EDomainClass.MonthlyStatement,
      EDomainClass.BankAccountStatement,
      EDomainClass.ExternalMonthlyStatement,
      EDomainClass.CreditCardMonthlyStatement,
      EDomainClass.PersonalExpenseMonthlyStatement,
    ],
    children: {
      [EDomainClass.BankAccountStatement]: {
        className: EDomainClass.BankAccountStatement,
        classNames: [EDomainClass.BankAccountStatement],
        children: {},
      },
      [EDomainClass.ExternalMonthlyStatement]: {
        className: EDomainClass.ExternalMonthlyStatement,
        classNames: [
          EDomainClass.ExternalMonthlyStatement,
          EDomainClass.CreditCardMonthlyStatement,
          EDomainClass.PersonalExpenseMonthlyStatement,
        ],
        children: {
          [EDomainClass.CreditCardMonthlyStatement]: {
            className: EDomainClass.CreditCardMonthlyStatement,
            classNames: [EDomainClass.CreditCardMonthlyStatement],
            children: {},
          },
          [EDomainClass.PersonalExpenseMonthlyStatement]: {
            className: EDomainClass.PersonalExpenseMonthlyStatement,
            classNames: [EDomainClass.PersonalExpenseMonthlyStatement],
            children: {},
          },
        },
      },
    },
  },
  [EDomainClass.CreditCardStatementLine]: {
    className: EDomainClass.CreditCardStatementLine,
    classNames: [EDomainClass.CreditCardStatementLine],
    children: {},
  },
  [EDomainClass.MyHandlingFbo]: {
    className: EDomainClass.MyHandlingFbo,
    classNames: [EDomainClass.MyHandlingFbo],
    children: {},
  },
  [EDomainClass.MyHandlingOrphanRequest]: {
    className: EDomainClass.MyHandlingOrphanRequest,
    classNames: [EDomainClass.MyHandlingOrphanRequest],
    children: {},
  },
  [EDomainClass.MyHandlingSyncState]: {
    className: EDomainClass.MyHandlingSyncState,
    classNames: [EDomainClass.MyHandlingSyncState],
    children: {},
  },
  [EDomainClass.PersistedEboxMessage]: {
    className: EDomainClass.PersistedEboxMessage,
    classNames: [EDomainClass.PersistedEboxMessage],
    children: {},
  },
  [EDomainClass.PersistedEboxMessageAttachment]: {
    className: EDomainClass.PersistedEboxMessageAttachment,
    classNames: [EDomainClass.PersistedEboxMessageAttachment],
    children: {},
  },
  [EDomainClass.BankAccountTransferFileRequest]: {
    className: EDomainClass.BankAccountTransferFileRequest,
    classNames: [EDomainClass.BankAccountTransferFileRequest],
    children: {},
  },
  [EDomainClass.PaymentMean]: {
    className: EDomainClass.PaymentMean,
    classNames: [
      EDomainClass.PaymentMean,
      EDomainClass.BankAccount,
      EDomainClass.CreditCard,
      EDomainClass.Domiciliation,
    ],
    children: {
      [EDomainClass.BankAccount]: {
        className: EDomainClass.BankAccount,
        classNames: [EDomainClass.BankAccount],
        children: {},
      },
      [EDomainClass.CreditCard]: {
        className: EDomainClass.CreditCard,
        classNames: [EDomainClass.CreditCard],
        children: {},
      },
      [EDomainClass.Domiciliation]: {
        className: EDomainClass.Domiciliation,
        classNames: [EDomainClass.Domiciliation],
        children: {},
      },
    },
  },
  [EDomainClass.BankAccountAuthorizedEntity]: {
    className: EDomainClass.BankAccountAuthorizedEntity,
    classNames: [EDomainClass.BankAccountAuthorizedEntity],
    children: {},
  },
  [EDomainClass.PeppolInboxDocument]: {
    className: EDomainClass.PeppolInboxDocument,
    classNames: [EDomainClass.PeppolInboxDocument],
    children: {},
  },
  [EDomainClass.PeppolInboxDocumentItem]: {
    className: EDomainClass.PeppolInboxDocumentItem,
    classNames: [EDomainClass.PeppolInboxDocumentItem],
    children: {},
  },
  [EDomainClass.PeppolSync]: {
    className: EDomainClass.PeppolSync,
    classNames: [EDomainClass.PeppolSync],
    children: {},
  },
  [EDomainClass.PeppolSyncQueue]: {
    className: EDomainClass.PeppolSyncQueue,
    classNames: [EDomainClass.PeppolSyncQueue],
    children: {},
  },
  [EDomainClass.PontoAccount]: {
    className: EDomainClass.PontoAccount,
    classNames: [EDomainClass.PontoAccount],
    children: {},
  },
  [EDomainClass.PontoInstitution]: {
    className: EDomainClass.PontoInstitution,
    classNames: [EDomainClass.PontoInstitution],
    children: {},
  },
  [EDomainClass.PontoMatchProposal]: {
    className: EDomainClass.PontoMatchProposal,
    classNames: [EDomainClass.PontoMatchProposal],
    children: {},
  },
  [EDomainClass.PontoSettings]: {
    className: EDomainClass.PontoSettings,
    classNames: [EDomainClass.PontoSettings],
    children: {},
  },
  [EDomainClass.PontoSynchronization]: {
    className: EDomainClass.PontoSynchronization,
    classNames: [EDomainClass.PontoSynchronization],
    children: {},
  },
  [EDomainClass.PontoTransaction]: {
    className: EDomainClass.PontoTransaction,
    classNames: [EDomainClass.PontoTransaction],
    children: {},
  },
  [EDomainClass.ReconciliationRule]: {
    className: EDomainClass.ReconciliationRule,
    classNames: [EDomainClass.ReconciliationRule],
    children: {},
  },
  [EDomainClass.LabelSetting]: {
    className: EDomainClass.LabelSetting,
    classNames: [EDomainClass.LabelSetting],
    children: {},
  },
  [EDomainClass.QuoteCalculationSupport]: {
    className: EDomainClass.QuoteCalculationSupport,
    classNames: [
      EDomainClass.QuoteCalculationSupport,
      EDomainClass.QuoteFuelConsumptionCalculationSupport,
      EDomainClass.QuoteFuelPriceCalculationSupport,
      EDomainClass.QuoteHandlingFeesCalculationSupport,
      EDomainClass.QuoteRateCalculationSupport,
    ],
    children: {
      [EDomainClass.QuoteFuelConsumptionCalculationSupport]: {
        className: EDomainClass.QuoteFuelConsumptionCalculationSupport,
        classNames: [EDomainClass.QuoteFuelConsumptionCalculationSupport],
        children: {},
      },
      [EDomainClass.QuoteFuelPriceCalculationSupport]: {
        className: EDomainClass.QuoteFuelPriceCalculationSupport,
        classNames: [EDomainClass.QuoteFuelPriceCalculationSupport],
        children: {},
      },
      [EDomainClass.QuoteHandlingFeesCalculationSupport]: {
        className: EDomainClass.QuoteHandlingFeesCalculationSupport,
        classNames: [EDomainClass.QuoteHandlingFeesCalculationSupport],
        children: {},
      },
      [EDomainClass.QuoteRateCalculationSupport]: {
        className: EDomainClass.QuoteRateCalculationSupport,
        classNames: [EDomainClass.QuoteRateCalculationSupport],
        children: {},
      },
    },
  },
  [EDomainClass.QuoteDay]: {
    className: EDomainClass.QuoteDay,
    classNames: [EDomainClass.QuoteDay],
    children: {},
  },
  [EDomainClass.QuoteFlight]: {
    className: EDomainClass.QuoteFlight,
    classNames: [EDomainClass.QuoteFlight],
    children: {},
  },
  [EDomainClass.QuoteFlightConfiguration]: {
    className: EDomainClass.QuoteFlightConfiguration,
    classNames: [EDomainClass.QuoteFlightConfiguration],
    children: {},
  },
  [EDomainClass.QuoteMission]: {
    className: EDomainClass.QuoteMission,
    classNames: [EDomainClass.QuoteMission],
    children: {},
  },
  [EDomainClass.QuoteMissionConfiguration]: {
    className: EDomainClass.QuoteMissionConfiguration,
    classNames: [EDomainClass.QuoteMissionConfiguration],
    children: {},
  },
  [EDomainClass.QuotePassenger]: {
    className: EDomainClass.QuotePassenger,
    classNames: [EDomainClass.QuotePassenger],
    children: {},
  },
  [EDomainClass.QuotePositioningSupport]: {
    className: EDomainClass.QuotePositioningSupport,
    classNames: [EDomainClass.QuotePositioningSupport],
    children: {},
  },
  [EDomainClass.RefuelEuAirport]: {
    className: EDomainClass.RefuelEuAirport,
    classNames: [EDomainClass.RefuelEuAirport],
    children: {},
  },
  [EDomainClass.RefuelEuAirportSnapshot]: {
    className: EDomainClass.RefuelEuAirportSnapshot,
    classNames: [EDomainClass.RefuelEuAirportSnapshot],
    children: {},
  },
  [EDomainClass.RefuelEuExemption]: {
    className: EDomainClass.RefuelEuExemption,
    classNames: [EDomainClass.RefuelEuExemption],
    children: {},
  },
  [EDomainClass.RefuelEuFlightException]: {
    className: EDomainClass.RefuelEuFlightException,
    classNames: [EDomainClass.RefuelEuFlightException],
    children: {},
  },
  [EDomainClass.RefuelEuFlightSnapshot]: {
    className: EDomainClass.RefuelEuFlightSnapshot,
    classNames: [EDomainClass.RefuelEuFlightSnapshot],
    children: {},
  },
  [EDomainClass.RefuelEuFuelMapping]: {
    className: EDomainClass.RefuelEuFuelMapping,
    classNames: [EDomainClass.RefuelEuFuelMapping],
    children: {},
  },
  [EDomainClass.RefuelEuNotificationConfig]: {
    className: EDomainClass.RefuelEuNotificationConfig,
    classNames: [EDomainClass.RefuelEuNotificationConfig],
    children: {},
  },
  [EDomainClass.RefuelEuOfpDivergence]: {
    className: EDomainClass.RefuelEuOfpDivergence,
    classNames: [EDomainClass.RefuelEuOfpDivergence],
    children: {},
  },
  [EDomainClass.RefuelEuPlannedOfp]: {
    className: EDomainClass.RefuelEuPlannedOfp,
    classNames: [EDomainClass.RefuelEuPlannedOfp],
    children: {},
  },
  [EDomainClass.RefuelEuReferencePrice]: {
    className: EDomainClass.RefuelEuReferencePrice,
    classNames: [EDomainClass.RefuelEuReferencePrice],
    children: {},
  },
  [EDomainClass.RefuelEuSafSupply]: {
    className: EDomainClass.RefuelEuSafSupply,
    classNames: [EDomainClass.RefuelEuSafSupply],
    children: {},
  },
  [EDomainClass.UserLinkedShareholder]: {
    className: EDomainClass.UserLinkedShareholder,
    classNames: [EDomainClass.UserLinkedShareholder],
    children: {},
  },
  [EDomainClass.UserShareholderJoinRequest]: {
    className: EDomainClass.UserShareholderJoinRequest,
    classNames: [EDomainClass.UserShareholderJoinRequest],
    children: {},
  },
  [EDomainClass.SkylegsSync]: {
    className: EDomainClass.SkylegsSync,
    classNames: [EDomainClass.SkylegsSync],
    children: {},
  },
  [EDomainClass.SkylegsSyncQueue]: {
    className: EDomainClass.SkylegsSyncQueue,
    classNames: [EDomainClass.SkylegsSyncQueue],
    children: {},
  },
  [EDomainClass.SkylegsWebhookSubscription]: {
    className: EDomainClass.SkylegsWebhookSubscription,
    classNames: [EDomainClass.SkylegsWebhookSubscription],
    children: {},
  },
  [EDomainClass.StockAllocation]: {
    className: EDomainClass.StockAllocation,
    classNames: [EDomainClass.StockAllocation],
    children: {},
  },
  [EDomainClass.StockInventoryCount]: {
    className: EDomainClass.StockInventoryCount,
    classNames: [EDomainClass.StockInventoryCount],
    children: {},
  },
  [EDomainClass.StockInventoryCountLine]: {
    className: EDomainClass.StockInventoryCountLine,
    classNames: [EDomainClass.StockInventoryCountLine],
    children: {},
  },
  [EDomainClass.StockInventorySheet]: {
    className: EDomainClass.StockInventorySheet,
    classNames: [EDomainClass.StockInventorySheet],
    children: {},
  },
  [EDomainClass.StockInventorySheetLine]: {
    className: EDomainClass.StockInventorySheetLine,
    classNames: [EDomainClass.StockInventorySheetLine],
    children: {},
  },
  [EDomainClass.StockLedgerLock]: {
    className: EDomainClass.StockLedgerLock,
    classNames: [EDomainClass.StockLedgerLock],
    children: {},
  },
  [EDomainClass.StockLot]: {
    className: EDomainClass.StockLot,
    classNames: [EDomainClass.StockLot],
    children: {},
  },
  [EDomainClass.StockMovement]: {
    className: EDomainClass.StockMovement,
    classNames: [EDomainClass.StockMovement],
    children: {},
  },
  [EDomainClass.StockProduct]: {
    className: EDomainClass.StockProduct,
    classNames: [EDomainClass.StockProduct],
    children: {},
  },
  [EDomainClass.StockReceipt]: {
    className: EDomainClass.StockReceipt,
    classNames: [EDomainClass.StockReceipt],
    children: {},
  },
  [EDomainClass.DailyTimesheetState]: {
    className: EDomainClass.DailyTimesheetState,
    classNames: [EDomainClass.DailyTimesheetState],
    children: {},
  },
  [EDomainClass.TimeClockLock]: {
    className: EDomainClass.TimeClockLock,
    classNames: [EDomainClass.TimeClockLock],
    children: {},
  },
  [EDomainClass.TimeDeclaration]: {
    className: EDomainClass.TimeDeclaration,
    classNames: [EDomainClass.TimeDeclaration],
    children: {},
  },
  [EDomainClass.TimeEvent]: {
    className: EDomainClass.TimeEvent,
    classNames: [EDomainClass.TimeEvent],
    children: {},
  },
  [EDomainClass.TimeKioskDevice]: {
    className: EDomainClass.TimeKioskDevice,
    classNames: [EDomainClass.TimeKioskDevice],
    children: {},
  },
  [EDomainClass.TimeOriginRefusal]: {
    className: EDomainClass.TimeOriginRefusal,
    classNames: [EDomainClass.TimeOriginRefusal],
    children: {},
  },
  [EDomainClass.TimeRuleSet]: {
    className: EDomainClass.TimeRuleSet,
    classNames: [EDomainClass.TimeRuleSet],
    children: {},
  },
  [EDomainClass.TimesheetEnrollment]: {
    className: EDomainClass.TimesheetEnrollment,
    classNames: [EDomainClass.TimesheetEnrollment],
    children: {},
  },
  [EDomainClass.TimesheetMonth]: {
    className: EDomainClass.TimesheetMonth,
    classNames: [EDomainClass.TimesheetMonth],
    children: {},
  },
  [EDomainClass.TimesheetMonthAudit]: {
    className: EDomainClass.TimesheetMonthAudit,
    classNames: [EDomainClass.TimesheetMonthAudit],
    children: {},
  },
  [EDomainClass.UserAgenda]: {
    className: EDomainClass.UserAgenda,
    classNames: [EDomainClass.UserAgenda],
    children: {},
  },
  [EDomainClass.UserAgendaEvent]: {
    className: EDomainClass.UserAgendaEvent,
    classNames: [
      EDomainClass.UserAgendaEvent,
      EDomainClass.UserAgendaFlightEvent,
      EDomainClass.UserAgendaGroundCourseEvent,
      EDomainClass.UserAgendaOfficeDutyEvent,
      EDomainClass.UserAgendaPositioningEvent,
      EDomainClass.UserAgendaPresenceEvent,
      EDomainClass.UserAgendaTrainingEvent,
    ],
    children: {
      [EDomainClass.UserAgendaFlightEvent]: {
        className: EDomainClass.UserAgendaFlightEvent,
        classNames: [EDomainClass.UserAgendaFlightEvent],
        children: {},
      },
      [EDomainClass.UserAgendaGroundCourseEvent]: {
        className: EDomainClass.UserAgendaGroundCourseEvent,
        classNames: [EDomainClass.UserAgendaGroundCourseEvent],
        children: {},
      },
      [EDomainClass.UserAgendaOfficeDutyEvent]: {
        className: EDomainClass.UserAgendaOfficeDutyEvent,
        classNames: [EDomainClass.UserAgendaOfficeDutyEvent],
        children: {},
      },
      [EDomainClass.UserAgendaPositioningEvent]: {
        className: EDomainClass.UserAgendaPositioningEvent,
        classNames: [EDomainClass.UserAgendaPositioningEvent],
        children: {},
      },
      [EDomainClass.UserAgendaPresenceEvent]: {
        className: EDomainClass.UserAgendaPresenceEvent,
        classNames: [EDomainClass.UserAgendaPresenceEvent],
        children: {},
      },
      [EDomainClass.UserAgendaTrainingEvent]: {
        className: EDomainClass.UserAgendaTrainingEvent,
        classNames: [EDomainClass.UserAgendaTrainingEvent],
        children: {},
      },
    },
  },
  [EDomainClass.Audit]: {
    className: EDomainClass.Audit,
    classNames: [EDomainClass.Audit],
    children: {},
  },
  [EDomainClass.AuditArea]: {
    className: EDomainClass.AuditArea,
    classNames: [EDomainClass.AuditArea],
    children: {},
  },
  [EDomainClass.AuditChecklist]: {
    className: EDomainClass.AuditChecklist,
    classNames: [EDomainClass.AuditChecklist],
    children: {},
  },
  [EDomainClass.AuditChecklistAnswer]: {
    className: EDomainClass.AuditChecklistAnswer,
    classNames: [EDomainClass.AuditChecklistAnswer],
    children: {},
  },
  [EDomainClass.AuditChecklistItem]: {
    className: EDomainClass.AuditChecklistItem,
    classNames: [EDomainClass.AuditChecklistItem],
    children: {},
  },
  [EDomainClass.AuditChecklistSnapshot]: {
    className: EDomainClass.AuditChecklistSnapshot,
    classNames: [EDomainClass.AuditChecklistSnapshot],
    children: {},
  },
  [EDomainClass.AuditCycleDefault]: {
    className: EDomainClass.AuditCycleDefault,
    classNames: [EDomainClass.AuditCycleDefault],
    children: {},
  },
  [EDomainClass.AuditFinding]: {
    className: EDomainClass.AuditFinding,
    classNames: [EDomainClass.AuditFinding],
    children: {},
  },
  [EDomainClass.AuditPlan]: {
    className: EDomainClass.AuditPlan,
    classNames: [EDomainClass.AuditPlan],
    children: {},
  },
  [EDomainClass.AuditPlanDeviation]: {
    className: EDomainClass.AuditPlanDeviation,
    classNames: [EDomainClass.AuditPlanDeviation],
    children: {},
  },
  [EDomainClass.AuditProgramme]: {
    className: EDomainClass.AuditProgramme,
    classNames: [EDomainClass.AuditProgramme],
    children: {},
  },
  [EDomainClass.AuditProgrammeArea]: {
    className: EDomainClass.AuditProgrammeArea,
    classNames: [EDomainClass.AuditProgrammeArea],
    children: {},
  },
  [EDomainClass.AuditProgrammeCycleExtension]: {
    className: EDomainClass.AuditProgrammeCycleExtension,
    classNames: [EDomainClass.AuditProgrammeCycleExtension],
    children: {},
  },
  [EDomainClass.AuditReport]: {
    className: EDomainClass.AuditReport,
    classNames: [EDomainClass.AuditReport],
    children: {},
  },
  [EDomainClass.AuditTimelineEvent]: {
    className: EDomainClass.AuditTimelineEvent,
    classNames: [EDomainClass.AuditTimelineEvent],
    children: {},
  },
  [EDomainClass.Auditor]: {
    className: EDomainClass.Auditor,
    classNames: [EDomainClass.Auditor],
    children: {},
  },
  [EDomainClass.AuditorQualification]: {
    className: EDomainClass.AuditorQualification,
    classNames: [EDomainClass.AuditorQualification],
    children: {},
  },
  [EDomainClass.CamoApprovalScopeLine]: {
    className: EDomainClass.CamoApprovalScopeLine,
    classNames: [EDomainClass.CamoApprovalScopeLine],
    children: {},
  },
  [EDomainClass.ChecklistFeedback]: {
    className: EDomainClass.ChecklistFeedback,
    classNames: [EDomainClass.ChecklistFeedback],
    children: {},
  },
  [EDomainClass.ChecklistQuestion]: {
    className: EDomainClass.ChecklistQuestion,
    classNames: [EDomainClass.ChecklistQuestion],
    children: {},
  },
  [EDomainClass.ChecklistQuestionDocLink]: {
    className: EDomainClass.ChecklistQuestionDocLink,
    classNames: [EDomainClass.ChecklistQuestionDocLink],
    children: {},
  },
  [EDomainClass.ChecklistQuestionLink]: {
    className: EDomainClass.ChecklistQuestionLink,
    classNames: [EDomainClass.ChecklistQuestionLink],
    children: {},
  },
  [EDomainClass.ChecklistResponseOption]: {
    className: EDomainClass.ChecklistResponseOption,
    classNames: [EDomainClass.ChecklistResponseOption],
    children: {},
  },
  [EDomainClass.ChecklistResponseSet]: {
    className: EDomainClass.ChecklistResponseSet,
    classNames: [EDomainClass.ChecklistResponseSet],
    children: {},
  },
  [EDomainClass.ChecklistSampling]: {
    className: EDomainClass.ChecklistSampling,
    classNames: [EDomainClass.ChecklistSampling],
    children: {},
  },
  [EDomainClass.ChecklistSamplingEntry]: {
    className: EDomainClass.ChecklistSamplingEntry,
    classNames: [EDomainClass.ChecklistSamplingEntry],
    children: {},
  },
  [EDomainClass.ChecklistTopic]: {
    className: EDomainClass.ChecklistTopic,
    classNames: [EDomainClass.ChecklistTopic],
    children: {},
  },
  [EDomainClass.ComplianceAuditTrailEntry]: {
    className: EDomainClass.ComplianceAuditTrailEntry,
    classNames: [EDomainClass.ComplianceAuditTrailEntry],
    children: {},
  },
  [EDomainClass.ComplianceCheckStep]: {
    className: EDomainClass.ComplianceCheckStep,
    classNames: [EDomainClass.ComplianceCheckStep],
    children: {},
  },
  [EDomainClass.ComplianceFramework]: {
    className: EDomainClass.ComplianceFramework,
    classNames: [EDomainClass.ComplianceFramework],
    children: {},
  },
  [EDomainClass.ComplianceImportBatch]: {
    className: EDomainClass.ComplianceImportBatch,
    classNames: [EDomainClass.ComplianceImportBatch],
    children: {},
  },
  [EDomainClass.ComplianceObservation]: {
    className: EDomainClass.ComplianceObservation,
    classNames: [EDomainClass.ComplianceObservation],
    children: {},
  },
  [EDomainClass.ComplianceScopeItem]: {
    className: EDomainClass.ComplianceScopeItem,
    classNames: [EDomainClass.ComplianceScopeItem],
    children: {},
  },
  [EDomainClass.ComplianceSignature]: {
    className: EDomainClass.ComplianceSignature,
    classNames: [EDomainClass.ComplianceSignature],
    children: {},
  },
  [EDomainClass.ComplianceSummaryReport]: {
    className: EDomainClass.ComplianceSummaryReport,
    classNames: [EDomainClass.ComplianceSummaryReport],
    children: {},
  },
  [EDomainClass.ComplianceTag]: {
    className: EDomainClass.ComplianceTag,
    classNames: [EDomainClass.ComplianceTag],
    children: {},
  },
  [EDomainClass.CorpusRevisionChange]: {
    className: EDomainClass.CorpusRevisionChange,
    classNames: [EDomainClass.CorpusRevisionChange],
    children: {},
  },
  [EDomainClass.CorpusStalenessCheck]: {
    className: EDomainClass.CorpusStalenessCheck,
    classNames: [EDomainClass.CorpusStalenessCheck],
    children: {},
  },
  [EDomainClass.CorrectiveAction]: {
    className: EDomainClass.CorrectiveAction,
    classNames: [EDomainClass.CorrectiveAction],
    children: {},
  },
  [EDomainClass.CorrectiveActionPlan]: {
    className: EDomainClass.CorrectiveActionPlan,
    classNames: [EDomainClass.CorrectiveActionPlan],
    children: {},
  },
  [EDomainClass.DeadlineExtension]: {
    className: EDomainClass.DeadlineExtension,
    classNames: [EDomainClass.DeadlineExtension],
    children: {},
  },
  [EDomainClass.DocumentTocEntry]: {
    className: EDomainClass.DocumentTocEntry,
    classNames: [EDomainClass.DocumentTocEntry],
    children: {},
  },
  [EDomainClass.DocumentaryImpact]: {
    className: EDomainClass.DocumentaryImpact,
    classNames: [EDomainClass.DocumentaryImpact],
    children: {},
  },
  [EDomainClass.EasaCatalogueEntry]: {
    className: EDomainClass.EasaCatalogueEntry,
    classNames: [EDomainClass.EasaCatalogueEntry],
    children: {},
  },
  [EDomainClass.EffectivenessReview]: {
    className: EDomainClass.EffectivenessReview,
    classNames: [EDomainClass.EffectivenessReview],
    children: {},
  },
  [EDomainClass.ExternalAuditEvent]: {
    className: EDomainClass.ExternalAuditEvent,
    classNames: [EDomainClass.ExternalAuditEvent],
    children: {},
  },
  [EDomainClass.ExternalRequirement]: {
    className: EDomainClass.ExternalRequirement,
    classNames: [EDomainClass.ExternalRequirement],
    children: {},
  },
  [EDomainClass.FindingSeverityScale]: {
    className: EDomainClass.FindingSeverityScale,
    classNames: [EDomainClass.FindingSeverityScale],
    children: {},
  },
  [EDomainClass.FindingStatusEntry]: {
    className: EDomainClass.FindingStatusEntry,
    classNames: [EDomainClass.FindingStatusEntry],
    children: {},
  },
  [EDomainClass.FunctionalResponsibility]: {
    className: EDomainClass.FunctionalResponsibility,
    classNames: [EDomainClass.FunctionalResponsibility],
    children: {},
  },
  [EDomainClass.IngestionLog]: {
    className: EDomainClass.IngestionLog,
    classNames: [EDomainClass.IngestionLog],
    children: {},
  },
  [EDomainClass.ManagementReview]: {
    className: EDomainClass.ManagementReview,
    classNames: [EDomainClass.ManagementReview],
    children: {},
  },
  [EDomainClass.ManagementReviewDecision]: {
    className: EDomainClass.ManagementReviewDecision,
    classNames: [EDomainClass.ManagementReviewDecision],
    children: {},
  },
  [EDomainClass.OrganisationComplianceProfile]: {
    className: EDomainClass.OrganisationComplianceProfile,
    classNames: [EDomainClass.OrganisationComplianceProfile],
    children: {},
  },
  [EDomainClass.PendingAmendment]: {
    className: EDomainClass.PendingAmendment,
    classNames: [EDomainClass.PendingAmendment],
    children: {},
  },
  [EDomainClass.PendingAmendmentTopicLink]: {
    className: EDomainClass.PendingAmendmentTopicLink,
    classNames: [EDomainClass.PendingAmendmentTopicLink],
    children: {},
  },
  [EDomainClass.PlannedAudit]: {
    className: EDomainClass.PlannedAudit,
    classNames: [EDomainClass.PlannedAudit],
    children: {},
  },
  [EDomainClass.QuestionDocReviewEntry]: {
    className: EDomainClass.QuestionDocReviewEntry,
    classNames: [EDomainClass.QuestionDocReviewEntry],
    children: {},
  },
  [EDomainClass.RampInspection]: {
    className: EDomainClass.RampInspection,
    classNames: [EDomainClass.RampInspection],
    children: {},
  },
  [EDomainClass.RampInspectionItem]: {
    className: EDomainClass.RampInspectionItem,
    classNames: [EDomainClass.RampInspectionItem],
    children: {},
  },
  [EDomainClass.RecordRetentionPolicy]: {
    className: EDomainClass.RecordRetentionPolicy,
    classNames: [EDomainClass.RecordRetentionPolicy],
    children: {},
  },
  [EDomainClass.ReferenceCounter]: {
    className: EDomainClass.ReferenceCounter,
    classNames: [EDomainClass.ReferenceCounter],
    children: {},
  },
  [EDomainClass.RegulatoryChangeAlert]: {
    className: EDomainClass.RegulatoryChangeAlert,
    classNames: [EDomainClass.RegulatoryChangeAlert],
    children: {},
  },
  [EDomainClass.RegulatoryDocument]: {
    className: EDomainClass.RegulatoryDocument,
    classNames: [EDomainClass.RegulatoryDocument],
    children: {},
  },
  [EDomainClass.RegulatoryTopic]: {
    className: EDomainClass.RegulatoryTopic,
    classNames: [EDomainClass.RegulatoryTopic],
    children: {},
  },
  [EDomainClass.RegulatoryTopicVersion]: {
    className: EDomainClass.RegulatoryTopicVersion,
    classNames: [EDomainClass.RegulatoryTopicVersion],
    children: {},
  },
  [EDomainClass.RepeatFindingLink]: {
    className: EDomainClass.RepeatFindingLink,
    classNames: [EDomainClass.RepeatFindingLink],
    children: {},
  },
  [EDomainClass.RequirementMapping]: {
    className: EDomainClass.RequirementMapping,
    classNames: [EDomainClass.RequirementMapping],
    children: {},
  },
  [EDomainClass.RiskLikelihoodLevel]: {
    className: EDomainClass.RiskLikelihoodLevel,
    classNames: [EDomainClass.RiskLikelihoodLevel],
    children: {},
  },
  [EDomainClass.RiskMatrixConfiguration]: {
    className: EDomainClass.RiskMatrixConfiguration,
    classNames: [EDomainClass.RiskMatrixConfiguration],
    children: {},
  },
  [EDomainClass.RiskSeverityLevel]: {
    className: EDomainClass.RiskSeverityLevel,
    classNames: [EDomainClass.RiskSeverityLevel],
    children: {},
  },
  [EDomainClass.RiskTolerabilityBand]: {
    className: EDomainClass.RiskTolerabilityBand,
    classNames: [EDomainClass.RiskTolerabilityBand],
    children: {},
  },
  [EDomainClass.RootCauseAnalysis]: {
    className: EDomainClass.RootCauseAnalysis,
    classNames: [EDomainClass.RootCauseAnalysis],
    children: {},
  },
  [EDomainClass.RootCauseItem]: {
    className: EDomainClass.RootCauseItem,
    classNames: [EDomainClass.RootCauseItem],
    children: {},
  },
  [EDomainClass.SpecificApproval]: {
    className: EDomainClass.SpecificApproval,
    classNames: [EDomainClass.SpecificApproval],
    children: {},
  },
  [EDomainClass.Supplier]: {
    className: EDomainClass.Supplier,
    classNames: [EDomainClass.Supplier],
    children: {},
  },
  [EDomainClass.Abbreviation]: {
    className: EDomainClass.Abbreviation,
    classNames: [EDomainClass.Abbreviation],
    children: {},
  },
  [EDomainClass.AuthorityHiddenAttachment]: {
    className: EDomainClass.AuthorityHiddenAttachment,
    classNames: [EDomainClass.AuthorityHiddenAttachment],
    children: {},
  },
  [EDomainClass.AuthorityMailFolder]: {
    className: EDomainClass.AuthorityMailFolder,
    classNames: [EDomainClass.AuthorityMailFolder],
    children: {},
  },
  [EDomainClass.AuthorityMessageTracker]: {
    className: EDomainClass.AuthorityMessageTracker,
    classNames: [EDomainClass.AuthorityMessageTracker],
    children: {},
  },
  [EDomainClass.AuthorityThreadFolderEntry]: {
    className: EDomainClass.AuthorityThreadFolderEntry,
    classNames: [EDomainClass.AuthorityThreadFolderEntry],
    children: {},
  },
  [EDomainClass.AuthorityThreadParticipant]: {
    className: EDomainClass.AuthorityThreadParticipant,
    classNames: [EDomainClass.AuthorityThreadParticipant],
    children: {},
  },
  [EDomainClass.ChecklistChangeNote]: {
    className: EDomainClass.ChecklistChangeNote,
    classNames: [EDomainClass.ChecklistChangeNote],
    children: {},
  },
  [EDomainClass.ChecklistItemAnchor]: {
    className: EDomainClass.ChecklistItemAnchor,
    classNames: [EDomainClass.ChecklistItemAnchor],
    children: {},
  },
  [EDomainClass.ComplianceAlert]: {
    className: EDomainClass.ComplianceAlert,
    classNames: [EDomainClass.ComplianceAlert],
    children: {},
  },
  [EDomainClass.ComplianceChecklist]: {
    className: EDomainClass.ComplianceChecklist,
    classNames: [EDomainClass.ComplianceChecklist],
    children: {},
  },
  [EDomainClass.ComplianceChecklistItem]: {
    className: EDomainClass.ComplianceChecklistItem,
    classNames: [EDomainClass.ComplianceChecklistItem],
    children: {},
  },
  [EDomainClass.ComplianceLink]: {
    className: EDomainClass.ComplianceLink,
    classNames: [EDomainClass.ComplianceLink],
    children: {},
  },
  [EDomainClass.Definition]: {
    className: EDomainClass.Definition,
    classNames: [EDomainClass.Definition],
    children: {},
  },
  [EDomainClass.Design]: {
    className: EDomainClass.Design,
    classNames: [EDomainClass.Design],
    children: {},
  },
  [EDomainClass.Diagram]: {
    className: EDomainClass.Diagram,
    classNames: [EDomainClass.Diagram],
    children: {},
  },
  [EDomainClass.DiagramCategory]: {
    className: EDomainClass.DiagramCategory,
    classNames: [EDomainClass.DiagramCategory],
    children: {},
  },
  [EDomainClass.DiagramRevision]: {
    className: EDomainClass.DiagramRevision,
    classNames: [EDomainClass.DiagramRevision],
    children: {},
  },
  [EDomainClass.DocumentCategory]: {
    className: EDomainClass.DocumentCategory,
    classNames: [EDomainClass.DocumentCategory],
    children: {},
  },
  [EDomainClass.DocumentCategoryMembership]: {
    className: EDomainClass.DocumentCategoryMembership,
    classNames: [EDomainClass.DocumentCategoryMembership],
    children: {},
  },
  [EDomainClass.DocumentSubmission]: {
    className: EDomainClass.DocumentSubmission,
    classNames: [EDomainClass.DocumentSubmission],
    children: {},
  },
  [EDomainClass.DocumentType]: {
    className: EDomainClass.DocumentType,
    classNames: [EDomainClass.DocumentType],
    children: {},
  },
  [EDomainClass.DocumentUserAssignment]: {
    className: EDomainClass.DocumentUserAssignment,
    classNames: [EDomainClass.DocumentUserAssignment],
    children: {},
  },
  [EDomainClass.DocumentationMediaEntry]: {
    className: EDomainClass.DocumentationMediaEntry,
    classNames: [EDomainClass.DocumentationMediaEntry],
    children: {},
  },
  [EDomainClass.DocumentationMediaEntryMembership]: {
    className: EDomainClass.DocumentationMediaEntryMembership,
    classNames: [EDomainClass.DocumentationMediaEntryMembership],
    children: {},
  },
  [EDomainClass.DocumentationMediaReference]: {
    className: EDomainClass.DocumentationMediaReference,
    classNames: [EDomainClass.DocumentationMediaReference],
    children: {},
  },
  [EDomainClass.DocumentationSettings]: {
    className: EDomainClass.DocumentationSettings,
    classNames: [EDomainClass.DocumentationSettings],
    children: {},
  },
  [EDomainClass.ManualDocument]: {
    className: EDomainClass.ManualDocument,
    classNames: [EDomainClass.ManualDocument],
    children: {},
  },
  [EDomainClass.Page]: {
    className: EDomainClass.Page,
    classNames: [EDomainClass.Page],
    children: {},
  },
  [EDomainClass.PageHeading]: {
    className: EDomainClass.PageHeading,
    classNames: [EDomainClass.PageHeading],
    children: {},
  },
  [EDomainClass.PageLabel]: {
    className: EDomainClass.PageLabel,
    classNames: [EDomainClass.PageLabel],
    children: {},
  },
  [EDomainClass.PageLabelAssignment]: {
    className: EDomainClass.PageLabelAssignment,
    classNames: [EDomainClass.PageLabelAssignment],
    children: {},
  },
  [EDomainClass.PageRevisionMetadata]: {
    className: EDomainClass.PageRevisionMetadata,
    classNames: [EDomainClass.PageRevisionMetadata],
    children: {},
  },
  [EDomainClass.PageSection]: {
    className: EDomainClass.PageSection,
    classNames: [EDomainClass.PageSection],
    children: {},
  },
  [EDomainClass.PageSectionRevisionMetadata]: {
    className: EDomainClass.PageSectionRevisionMetadata,
    classNames: [EDomainClass.PageSectionRevisionMetadata],
    children: {},
  },
  [EDomainClass.PageSectionSnapshot]: {
    className: EDomainClass.PageSectionSnapshot,
    classNames: [EDomainClass.PageSectionSnapshot],
    children: {},
  },
  [EDomainClass.PageSnapshot]: {
    className: EDomainClass.PageSnapshot,
    classNames: [EDomainClass.PageSnapshot],
    children: {},
  },
  [EDomainClass.PageWorkflowHistory]: {
    className: EDomainClass.PageWorkflowHistory,
    classNames: [EDomainClass.PageWorkflowHistory],
    children: {},
  },
  [EDomainClass.PageWorkflowState]: {
    className: EDomainClass.PageWorkflowState,
    classNames: [EDomainClass.PageWorkflowState],
    children: {},
  },
  [EDomainClass.Revision]: {
    className: EDomainClass.Revision,
    classNames: [EDomainClass.Revision],
    children: {},
  },
  [EDomainClass.RevisionReminder]: {
    className: EDomainClass.RevisionReminder,
    classNames: [EDomainClass.RevisionReminder],
    children: {},
  },
  [EDomainClass.SharedFileLink]: {
    className: EDomainClass.SharedFileLink,
    classNames: [EDomainClass.SharedFileLink],
    children: {},
  },
  [EDomainClass.SharedFileLinkDownload]: {
    className: EDomainClass.SharedFileLinkDownload,
    classNames: [EDomainClass.SharedFileLinkDownload],
    children: {},
  },
  [EDomainClass.SmartModule]: {
    className: EDomainClass.SmartModule,
    classNames: [EDomainClass.SmartModule],
    children: {},
  },
  [EDomainClass.SupervisoryAuthority]: {
    className: EDomainClass.SupervisoryAuthority,
    classNames: [EDomainClass.SupervisoryAuthority],
    children: {},
  },
  [EDomainClass.SupervisoryAuthorityContact]: {
    className: EDomainClass.SupervisoryAuthorityContact,
    classNames: [EDomainClass.SupervisoryAuthorityContact],
    children: {},
  },
  [EDomainClass.WorkflowDefinition]: {
    className: EDomainClass.WorkflowDefinition,
    classNames: [EDomainClass.WorkflowDefinition],
    children: {},
  },
  [EDomainClass.WorkflowStep]: {
    className: EDomainClass.WorkflowStep,
    classNames: [EDomainClass.WorkflowStep],
    children: {},
  },
  [EDomainClass.WebmanualsConnection]: {
    className: EDomainClass.WebmanualsConnection,
    classNames: [EDomainClass.WebmanualsConnection],
    children: {},
  },
  [EDomainClass.WebmanualsImportPhase]: {
    className: EDomainClass.WebmanualsImportPhase,
    classNames: [EDomainClass.WebmanualsImportPhase],
    children: {},
  },
  [EDomainClass.WebmanualsImportRun]: {
    className: EDomainClass.WebmanualsImportRun,
    classNames: [EDomainClass.WebmanualsImportRun],
    children: {},
  },
  [EDomainClass.DocCategory]: {
    className: EDomainClass.DocCategory,
    classNames: [EDomainClass.DocCategory],
    children: {},
  },
  [EDomainClass.DocDocument]: {
    className: EDomainClass.DocDocument,
    classNames: [EDomainClass.DocDocument],
    children: {},
  },
  [EDomainClass.DocSignature]: {
    className: EDomainClass.DocSignature,
    classNames: [EDomainClass.DocSignature],
    children: {},
  },
  [EDomainClass.DocVersion]: {
    className: EDomainClass.DocVersion,
    classNames: [EDomainClass.DocVersion],
    children: {},
  },
  [EDomainClass.PostHolder]: {
    className: EDomainClass.PostHolder,
    classNames: [EDomainClass.PostHolder],
    children: {},
  },
  [EDomainClass.PostHolderAssignment]: {
    className: EDomainClass.PostHolderAssignment,
    classNames: [EDomainClass.PostHolderAssignment],
    children: {},
  },
  [EDomainClass.FlightWish]: {
    className: EDomainClass.FlightWish,
    classNames: [EDomainClass.FlightWish],
    children: {},
  },
  [EDomainClass.FlightWishMatch]: {
    className: EDomainClass.FlightWishMatch,
    classNames: [EDomainClass.FlightWishMatch],
    children: {},
  },
  [EDomainClass.BankAccountValidationRequest]: {
    className: EDomainClass.BankAccountValidationRequest,
    classNames: [EDomainClass.BankAccountValidationRequest],
    children: {},
  },
  [EDomainClass.CardLineProposal]: {
    className: EDomainClass.CardLineProposal,
    classNames: [EDomainClass.CardLineProposal],
    children: {},
  },
  [EDomainClass.EurocontrolFlightLine]: {
    className: EDomainClass.EurocontrolFlightLine,
    classNames: [EDomainClass.EurocontrolFlightLine],
    children: {},
  },
  [EDomainClass.ExpenseInboxSettings]: {
    className: EDomainClass.ExpenseInboxSettings,
    classNames: [EDomainClass.ExpenseInboxSettings],
    children: {},
  },
  [EDomainClass.ExtractionEvalResult]: {
    className: EDomainClass.ExtractionEvalResult,
    classNames: [EDomainClass.ExtractionEvalResult],
    children: {},
  },
  [EDomainClass.ExtractionEvalRun]: {
    className: EDomainClass.ExtractionEvalRun,
    classNames: [EDomainClass.ExtractionEvalRun],
    children: {},
  },
  [EDomainClass.InboundDocument]: {
    className: EDomainClass.InboundDocument,
    classNames: [EDomainClass.InboundDocument],
    children: {},
  },
  [EDomainClass.InboundDocumentItem]: {
    className: EDomainClass.InboundDocumentItem,
    classNames: [EDomainClass.InboundDocumentItem],
    children: {},
  },
  [EDomainClass.MerchantSupplierMapping]: {
    className: EDomainClass.MerchantSupplierMapping,
    classNames: [EDomainClass.MerchantSupplierMapping],
    children: {},
  },
  [EDomainClass.OcrCacheEntry]: {
    className: EDomainClass.OcrCacheEntry,
    classNames: [EDomainClass.OcrCacheEntry],
    children: {},
  },
  [EDomainClass.PipelineRuntimeState]: {
    className: EDomainClass.PipelineRuntimeState,
    classNames: [EDomainClass.PipelineRuntimeState],
    children: {},
  },
  [EDomainClass.ReceiptSubmission]: {
    className: EDomainClass.ReceiptSubmission,
    classNames: [EDomainClass.ReceiptSubmission],
    children: {},
  },
  [EDomainClass.SupplierAutomationRule]: {
    className: EDomainClass.SupplierAutomationRule,
    classNames: [EDomainClass.SupplierAutomationRule],
    children: {},
  },
  [EDomainClass.SupplierCategoryRule]: {
    className: EDomainClass.SupplierCategoryRule,
    classNames: [EDomainClass.SupplierCategoryRule],
    children: {},
  },
  [EDomainClass.SupplierCreationRequest]: {
    className: EDomainClass.SupplierCreationRequest,
    classNames: [EDomainClass.SupplierCreationRequest],
    children: {},
  },
  [EDomainClass.SupplierDateFormatRule]: {
    className: EDomainClass.SupplierDateFormatRule,
    classNames: [EDomainClass.SupplierDateFormatRule],
    children: {},
  },
  [EDomainClass.CrewDocumentSubmission]: {
    className: EDomainClass.CrewDocumentSubmission,
    classNames: [EDomainClass.CrewDocumentSubmission],
    children: {},
  },
  [EDomainClass.CrewTravelDocument]: {
    className: EDomainClass.CrewTravelDocument,
    classNames: [EDomainClass.CrewTravelDocument],
    children: {},
  },
  [EDomainClass.ExaminerCertificate]: {
    className: EDomainClass.ExaminerCertificate,
    classNames: [EDomainClass.ExaminerCertificate],
    children: {},
  },
  [EDomainClass.InstructorCertificate]: {
    className: EDomainClass.InstructorCertificate,
    classNames: [EDomainClass.InstructorCertificate],
    children: {},
  },
  [EDomainClass.LanguageProficiency]: {
    className: EDomainClass.LanguageProficiency,
    classNames: [EDomainClass.LanguageProficiency],
    children: {},
  },
  [EDomainClass.Licence]: {
    className: EDomainClass.Licence,
    classNames: [EDomainClass.Licence],
    children: {},
  },
  [EDomainClass.MedicalCertificate]: {
    className: EDomainClass.MedicalCertificate,
    classNames: [EDomainClass.MedicalCertificate],
    children: {},
  },
  [EDomainClass.MedicalCertificateClassValidity]: {
    className: EDomainClass.MedicalCertificateClassValidity,
    classNames: [EDomainClass.MedicalCertificateClassValidity],
    children: {},
  },
  [EDomainClass.MedicalCertificateRestriction]: {
    className: EDomainClass.MedicalCertificateRestriction,
    classNames: [EDomainClass.MedicalCertificateRestriction],
    children: {},
  },
  [EDomainClass.Rating]: {
    className: EDomainClass.Rating,
    classNames: [EDomainClass.Rating],
    children: {},
  },
  [EDomainClass.RatingOccurrence]: {
    className: EDomainClass.RatingOccurrence,
    classNames: [EDomainClass.RatingOccurrence],
    children: {},
  },
  [EDomainClass.AdRequirement]: {
    className: EDomainClass.AdRequirement,
    classNames: [EDomainClass.AdRequirement],
    children: {},
  },
  [EDomainClass.AdRequirementTask]: {
    className: EDomainClass.AdRequirementTask,
    classNames: [EDomainClass.AdRequirementTask],
    children: {},
  },
  [EDomainClass.AircraftAppointment]: {
    className: EDomainClass.AircraftAppointment,
    classNames: [EDomainClass.AircraftAppointment],
    children: {},
  },
  [EDomainClass.AircraftComponent]: {
    className: EDomainClass.AircraftComponent,
    classNames: [EDomainClass.AircraftComponent],
    children: {},
  },
  [EDomainClass.AircraftStatusReport]: {
    className: EDomainClass.AircraftStatusReport,
    classNames: [EDomainClass.AircraftStatusReport],
    children: {},
  },
  [EDomainClass.AirworthinessDirective]: {
    className: EDomainClass.AirworthinessDirective,
    classNames: [EDomainClass.AirworthinessDirective],
    children: {},
  },
  [EDomainClass.AogPeriod]: {
    className: EDomainClass.AogPeriod,
    classNames: [EDomainClass.AogPeriod],
    children: {},
  },
  [EDomainClass.AssessmentLine]: {
    className: EDomainClass.AssessmentLine,
    classNames: [EDomainClass.AssessmentLine],
    children: {},
  },
  [EDomainClass.CamoManagementContract]: {
    className: EDomainClass.CamoManagementContract,
    classNames: [EDomainClass.CamoManagementContract],
    children: {},
  },
  [EDomainClass.ComponentReplacement]: {
    className: EDomainClass.ComponentReplacement,
    classNames: [EDomainClass.ComponentReplacement],
    children: {},
  },
  [EDomainClass.CounterReading]: {
    className: EDomainClass.CounterReading,
    classNames: [EDomainClass.CounterReading],
    children: {},
  },
  [EDomainClass.Defect]: {
    className: EDomainClass.Defect,
    classNames: [EDomainClass.Defect],
    children: {},
  },
  [EDomainClass.DefectNotificationState]: {
    className: EDomainClass.DefectNotificationState,
    classNames: [EDomainClass.DefectNotificationState],
    children: {},
  },
  [EDomainClass.DirectiveApplicability]: {
    className: EDomainClass.DirectiveApplicability,
    classNames: [EDomainClass.DirectiveApplicability],
    children: {},
  },
  [EDomainClass.DirectiveCompliance]: {
    className: EDomainClass.DirectiveCompliance,
    classNames: [EDomainClass.DirectiveCompliance],
    children: {},
  },
  [EDomainClass.DirectiveNotificationState]: {
    className: EDomainClass.DirectiveNotificationState,
    classNames: [EDomainClass.DirectiveNotificationState],
    children: {},
  },
  [EDomainClass.DirectiveReview]: {
    className: EDomainClass.DirectiveReview,
    classNames: [EDomainClass.DirectiveReview],
    children: {},
  },
  [EDomainClass.ExternalWorkPackage]: {
    className: EDomainClass.ExternalWorkPackage,
    classNames: [EDomainClass.ExternalWorkPackage],
    children: {},
  },
  [EDomainClass.FleetStatusReport]: {
    className: EDomainClass.FleetStatusReport,
    classNames: [EDomainClass.FleetStatusReport],
    children: {},
  },
  [EDomainClass.FleetStatusSnapshot]: {
    className: EDomainClass.FleetStatusSnapshot,
    classNames: [EDomainClass.FleetStatusSnapshot],
    children: {},
  },
  [EDomainClass.ImportBatch]: {
    className: EDomainClass.ImportBatch,
    classNames: [EDomainClass.ImportBatch],
    children: {},
  },
  [EDomainClass.ImportLine]: {
    className: EDomainClass.ImportLine,
    classNames: [EDomainClass.ImportLine],
    children: {},
  },
  [EDomainClass.InstallationEvent]: {
    className: EDomainClass.InstallationEvent,
    classNames: [EDomainClass.InstallationEvent],
    children: {},
  },
  [EDomainClass.LifeLimit]: {
    className: EDomainClass.LifeLimit,
    classNames: [EDomainClass.LifeLimit],
    children: {},
  },
  [EDomainClass.LogbookEntry]: {
    className: EDomainClass.LogbookEntry,
    classNames: [EDomainClass.LogbookEntry],
    children: {},
  },
  [EDomainClass.MaintenanceConfiguration]: {
    className: EDomainClass.MaintenanceConfiguration,
    classNames: [EDomainClass.MaintenanceConfiguration],
    children: {},
  },
  [EDomainClass.MaintenanceDocument]: {
    className: EDomainClass.MaintenanceDocument,
    classNames: [EDomainClass.MaintenanceDocument],
    children: {},
  },
  [EDomainClass.MaintenanceDocumentLink]: {
    className: EDomainClass.MaintenanceDocumentLink,
    classNames: [EDomainClass.MaintenanceDocumentLink],
    children: {},
  },
  [EDomainClass.MaintenanceProgramme]: {
    className: EDomainClass.MaintenanceProgramme,
    classNames: [EDomainClass.MaintenanceProgramme],
    children: {},
  },
  [EDomainClass.MaintenancePublication]: {
    className: EDomainClass.MaintenancePublication,
    classNames: [EDomainClass.MaintenancePublication],
    children: {},
  },
  [EDomainClass.MaintenanceRelease]: {
    className: EDomainClass.MaintenanceRelease,
    classNames: [EDomainClass.MaintenanceRelease],
    children: {},
  },
  [EDomainClass.MaintenanceSlot]: {
    className: EDomainClass.MaintenanceSlot,
    classNames: [EDomainClass.MaintenanceSlot],
    children: {},
  },
  [EDomainClass.MaintenanceTask]: {
    className: EDomainClass.MaintenanceTask,
    classNames: [EDomainClass.MaintenanceTask],
    children: {},
  },
  [EDomainClass.MajorAssembly]: {
    className: EDomainClass.MajorAssembly,
    classNames: [EDomainClass.MajorAssembly],
    children: {},
  },
  [EDomainClass.OnboardDocument]: {
    className: EDomainClass.OnboardDocument,
    classNames: [EDomainClass.OnboardDocument],
    children: {},
  },
  [EDomainClass.ProgrammeRevision]: {
    className: EDomainClass.ProgrammeRevision,
    classNames: [EDomainClass.ProgrammeRevision],
    children: {},
  },
  [EDomainClass.ProgrammeRevisionBasis]: {
    className: EDomainClass.ProgrammeRevisionBasis,
    classNames: [EDomainClass.ProgrammeRevisionBasis],
    children: {},
  },
  [EDomainClass.ProgrammeTemporaryRevision]: {
    className: EDomainClass.ProgrammeTemporaryRevision,
    classNames: [EDomainClass.ProgrammeTemporaryRevision],
    children: {},
  },
  [EDomainClass.ProgrammeToleranceDefault]: {
    className: EDomainClass.ProgrammeToleranceDefault,
    classNames: [EDomainClass.ProgrammeToleranceDefault],
    children: {},
  },
  [EDomainClass.PublicationAssessment]: {
    className: EDomainClass.PublicationAssessment,
    classNames: [EDomainClass.PublicationAssessment],
    children: {},
  },
  [EDomainClass.PublicationRevision]: {
    className: EDomainClass.PublicationRevision,
    classNames: [EDomainClass.PublicationRevision],
    children: {},
  },
  [EDomainClass.SbCategoryMapping]: {
    className: EDomainClass.SbCategoryMapping,
    classNames: [EDomainClass.SbCategoryMapping],
    children: {},
  },
  [EDomainClass.ServiceBulletin]: {
    className: EDomainClass.ServiceBulletin,
    classNames: [EDomainClass.ServiceBulletin],
    children: {},
  },
  [EDomainClass.TaskAdjustment]: {
    className: EDomainClass.TaskAdjustment,
    classNames: [EDomainClass.TaskAdjustment],
    children: {},
  },
  [EDomainClass.TaskApplicability]: {
    className: EDomainClass.TaskApplicability,
    classNames: [EDomainClass.TaskApplicability],
    children: {},
  },
  [EDomainClass.TaskCompliance]: {
    className: EDomainClass.TaskCompliance,
    classNames: [EDomainClass.TaskCompliance],
    children: {},
  },
  [EDomainClass.TaskNotificationState]: {
    className: EDomainClass.TaskNotificationState,
    classNames: [EDomainClass.TaskNotificationState],
    children: {},
  },
  [EDomainClass.TaskRequirement]: {
    className: EDomainClass.TaskRequirement,
    classNames: [EDomainClass.TaskRequirement],
    children: {},
  },
  [EDomainClass.UsageCounter]: {
    className: EDomainClass.UsageCounter,
    classNames: [EDomainClass.UsageCounter],
    children: {},
  },
  [EDomainClass.UtilisationEntry]: {
    className: EDomainClass.UtilisationEntry,
    classNames: [EDomainClass.UtilisationEntry],
    children: {},
  },
  [EDomainClass.WeighingRecord]: {
    className: EDomainClass.WeighingRecord,
    classNames: [EDomainClass.WeighingRecord],
    children: {},
  },
  [EDomainClass.WorkOrder]: {
    className: EDomainClass.WorkOrder,
    classNames: [EDomainClass.WorkOrder],
    children: {},
  },
  [EDomainClass.WorkOrderItem]: {
    className: EDomainClass.WorkOrderItem,
    classNames: [EDomainClass.WorkOrderItem],
    children: {},
  },
  [EDomainClass.MdmActivationLockBypass]: {
    className: EDomainClass.MdmActivationLockBypass,
    classNames: [EDomainClass.MdmActivationLockBypass],
    children: {},
  },
  [EDomainClass.MdmApp]: {
    className: EDomainClass.MdmApp,
    classNames: [EDomainClass.MdmApp],
    children: {},
  },
  [EDomainClass.MdmAppCategory]: {
    className: EDomainClass.MdmAppCategory,
    classNames: [EDomainClass.MdmAppCategory],
    children: {},
  },
  [EDomainClass.MdmAppLicense]: {
    className: EDomainClass.MdmAppLicense,
    classNames: [EDomainClass.MdmAppLicense],
    children: {},
  },
  [EDomainClass.MdmDepProfile]: {
    className: EDomainClass.MdmDepProfile,
    classNames: [EDomainClass.MdmDepProfile],
    children: {},
  },
  [EDomainClass.MdmDevicePackage]: {
    className: EDomainClass.MdmDevicePackage,
    classNames: [EDomainClass.MdmDevicePackage],
    children: {},
  },
  [EDomainClass.MdmDeviceProfile]: {
    className: EDomainClass.MdmDeviceProfile,
    classNames: [EDomainClass.MdmDeviceProfile],
    children: {},
  },
  [EDomainClass.MdmDeviceSecret]: {
    className: EDomainClass.MdmDeviceSecret,
    classNames: [EDomainClass.MdmDeviceSecret],
    children: {},
  },
  [EDomainClass.MdmDeviceSnapshot]: {
    className: EDomainClass.MdmDeviceSnapshot,
    classNames: [EDomainClass.MdmDeviceSnapshot],
    children: {},
  },
  [EDomainClass.MdmEnrollmentHookExecution]: {
    className: EDomainClass.MdmEnrollmentHookExecution,
    classNames: [EDomainClass.MdmEnrollmentHookExecution],
    children: {},
  },
  [EDomainClass.MdmPackage]: {
    className: EDomainClass.MdmPackage,
    classNames: [EDomainClass.MdmPackage],
    children: {},
  },
  [EDomainClass.MdmPayload]: {
    className: EDomainClass.MdmPayload,
    classNames: [EDomainClass.MdmPayload],
    children: {},
  },
  [EDomainClass.MdmProfile]: {
    className: EDomainClass.MdmProfile,
    classNames: [EDomainClass.MdmProfile],
    children: {},
  },
  [EDomainClass.MdmScheduledCommand]: {
    className: EDomainClass.MdmScheduledCommand,
    classNames: [EDomainClass.MdmScheduledCommand],
    children: {},
  },
  [EDomainClass.MdmSmartGroup]: {
    className: EDomainClass.MdmSmartGroup,
    classNames: [EDomainClass.MdmSmartGroup],
    children: {},
  },
  [EDomainClass.CrewAppLinkInvitation]: {
    className: EDomainClass.CrewAppLinkInvitation,
    classNames: [EDomainClass.CrewAppLinkInvitation],
    children: {},
  },
  [EDomainClass.CrewProfileStamp]: {
    className: EDomainClass.CrewProfileStamp,
    classNames: [EDomainClass.CrewProfileStamp],
    children: {},
  },
  [EDomainClass.CrewTodo]: {
    className: EDomainClass.CrewTodo,
    classNames: [EDomainClass.CrewTodo],
    children: {},
  },
  [EDomainClass.EmployeeStamp]: {
    className: EDomainClass.EmployeeStamp,
    classNames: [EDomainClass.EmployeeStamp],
    children: {},
  },
  [EDomainClass.MobileAppLastSeen]: {
    className: EDomainClass.MobileAppLastSeen,
    classNames: [EDomainClass.MobileAppLastSeen],
    children: {},
  },
  [EDomainClass.MobileFeatureFlag]: {
    className: EDomainClass.MobileFeatureFlag,
    classNames: [EDomainClass.MobileFeatureFlag],
    children: {},
  },
  [EDomainClass.ProcessedMutation]: {
    className: EDomainClass.ProcessedMutation,
    classNames: [EDomainClass.ProcessedMutation],
    children: {},
  },
  [EDomainClass.RefuelEuAirportStatus]: {
    className: EDomainClass.RefuelEuAirportStatus,
    classNames: [EDomainClass.RefuelEuAirportStatus],
    children: {},
  },
  [EDomainClass.SyncSequence]: {
    className: EDomainClass.SyncSequence,
    classNames: [EDomainClass.SyncSequence],
    children: {},
  },
  [EDomainClass.SyncTombstone]: {
    className: EDomainClass.SyncTombstone,
    classNames: [EDomainClass.SyncTombstone],
    children: {},
  },
  [EDomainClass.OfficeDutyProposal]: {
    className: EDomainClass.OfficeDutyProposal,
    classNames: [EDomainClass.OfficeDutyProposal],
    children: {},
  },
  [EDomainClass.OptimizationReport]: {
    className: EDomainClass.OptimizationReport,
    classNames: [EDomainClass.OptimizationReport],
    children: {},
  },
  [EDomainClass.ProcurementContract]: {
    className: EDomainClass.ProcurementContract,
    classNames: [EDomainClass.ProcurementContract],
    children: {},
  },
  [EDomainClass.ProcurementContractAmendment]: {
    className: EDomainClass.ProcurementContractAmendment,
    classNames: [EDomainClass.ProcurementContractAmendment],
    children: {},
  },
  [EDomainClass.ProcurementContractCoveredPerson]: {
    className: EDomainClass.ProcurementContractCoveredPerson,
    classNames: [EDomainClass.ProcurementContractCoveredPerson],
    children: {},
  },
  [EDomainClass.ProcurementContractDocument]: {
    className: EDomainClass.ProcurementContractDocument,
    classNames: [EDomainClass.ProcurementContractDocument],
    children: {},
  },
  [EDomainClass.Prospect]: {
    className: EDomainClass.Prospect,
    classNames: [EDomainClass.Prospect],
    children: {},
  },
  [EDomainClass.ProspectContact]: {
    className: EDomainClass.ProspectContact,
    classNames: [EDomainClass.ProspectContact],
    children: {},
  },
  [EDomainClass.ProspectCrmSettings]: {
    className: EDomainClass.ProspectCrmSettings,
    classNames: [EDomainClass.ProspectCrmSettings],
    children: {},
  },
  [EDomainClass.ProspectGdprConsent]: {
    className: EDomainClass.ProspectGdprConsent,
    classNames: [EDomainClass.ProspectGdprConsent],
    children: {},
  },
  [EDomainClass.ProspectInteraction]: {
    className: EDomainClass.ProspectInteraction,
    classNames: [EDomainClass.ProspectInteraction],
    children: {},
  },
  [EDomainClass.ProspectNextAction]: {
    className: EDomainClass.ProspectNextAction,
    classNames: [EDomainClass.ProspectNextAction],
    children: {},
  },
  [EDomainClass.ProspectStageTransition]: {
    className: EDomainClass.ProspectStageTransition,
    classNames: [EDomainClass.ProspectStageTransition],
    children: {},
  },
  [EDomainClass.ProspectTask]: {
    className: EDomainClass.ProspectTask,
    classNames: [EDomainClass.ProspectTask],
    children: {},
  },
  [EDomainClass.TypicalMission]: {
    className: EDomainClass.TypicalMission,
    classNames: [EDomainClass.TypicalMission],
    children: {},
  },
  [EDomainClass.DossierPromptTemplate]: {
    className: EDomainClass.DossierPromptTemplate,
    classNames: [EDomainClass.DossierPromptTemplate],
    children: {},
  },
  [EDomainClass.ProspectDossier]: {
    className: EDomainClass.ProspectDossier,
    classNames: [EDomainClass.ProspectDossier],
    children: {},
  },
  [EDomainClass.CostEstimation]: {
    className: EDomainClass.CostEstimation,
    classNames: [EDomainClass.CostEstimation],
    children: {},
  },
  [EDomainClass.CostEstimationLine]: {
    className: EDomainClass.CostEstimationLine,
    classNames: [EDomainClass.CostEstimationLine],
    children: {},
  },
  [EDomainClass.CostEstimationScenario]: {
    className: EDomainClass.CostEstimationScenario,
    classNames: [EDomainClass.CostEstimationScenario],
    children: {},
  },
  [EDomainClass.ParticipationStep]: {
    className: EDomainClass.ParticipationStep,
    classNames: [EDomainClass.ParticipationStep],
    children: {},
  },
  [EDomainClass.ProspectEstimationSettings]: {
    className: EDomainClass.ProspectEstimationSettings,
    classNames: [EDomainClass.ProspectEstimationSettings],
    children: {},
  },
  [EDomainClass.EccairsSubmission]: {
    className: EDomainClass.EccairsSubmission,
    classNames: [EDomainClass.EccairsSubmission],
    children: {},
  },
  [EDomainClass.EccairsValueListEntry]: {
    className: EDomainClass.EccairsValueListEntry,
    classNames: [EDomainClass.EccairsValueListEntry],
    children: {},
  },
  [EDomainClass.ErpEvent]: {
    className: EDomainClass.ErpEvent,
    classNames: [EDomainClass.ErpEvent],
    children: {},
  },
  [EDomainClass.ErpEventDebrief]: {
    className: EDomainClass.ErpEventDebrief,
    classNames: [EDomainClass.ErpEventDebrief],
    children: {},
  },
  [EDomainClass.ErpEventParticipant]: {
    className: EDomainClass.ErpEventParticipant,
    classNames: [EDomainClass.ErpEventParticipant],
    children: {},
  },
  [EDomainClass.ExternalSafetyPublication]: {
    className: EDomainClass.ExternalSafetyPublication,
    classNames: [EDomainClass.ExternalSafetyPublication],
    children: {},
  },
  [EDomainClass.FlightRiskAssessment]: {
    className: EDomainClass.FlightRiskAssessment,
    classNames: [EDomainClass.FlightRiskAssessment],
    children: {},
  },
  [EDomainClass.ForasFactor]: {
    className: EDomainClass.ForasFactor,
    classNames: [EDomainClass.ForasFactor],
    children: {},
  },
  [EDomainClass.ForasFactorAnswer]: {
    className: EDomainClass.ForasFactorAnswer,
    classNames: [EDomainClass.ForasFactorAnswer],
    children: {},
  },
  [EDomainClass.HazardTaxonomyNode]: {
    className: EDomainClass.HazardTaxonomyNode,
    classNames: [EDomainClass.HazardTaxonomyNode],
    children: {},
  },
  [EDomainClass.JustCultureReview]: {
    className: EDomainClass.JustCultureReview,
    classNames: [EDomainClass.JustCultureReview],
    children: {},
  },
  [EDomainClass.ManagementOfChange]: {
    className: EDomainClass.ManagementOfChange,
    classNames: [EDomainClass.ManagementOfChange],
    children: {},
  },
  [EDomainClass.MandatoryOccurrenceCriterion]: {
    className: EDomainClass.MandatoryOccurrenceCriterion,
    classNames: [EDomainClass.MandatoryOccurrenceCriterion],
    children: {},
  },
  [EDomainClass.OccurrenceEventLink]: {
    className: EDomainClass.OccurrenceEventLink,
    classNames: [EDomainClass.OccurrenceEventLink],
    children: {},
  },
  [EDomainClass.SafetyAcceptancePrinciple]: {
    className: EDomainClass.SafetyAcceptancePrinciple,
    classNames: [EDomainClass.SafetyAcceptancePrinciple],
    children: {},
  },
  [EDomainClass.SafetyAction]: {
    className: EDomainClass.SafetyAction,
    classNames: [EDomainClass.SafetyAction],
    children: {},
  },
  [EDomainClass.SafetyActionSignOff]: {
    className: EDomainClass.SafetyActionSignOff,
    classNames: [EDomainClass.SafetyActionSignOff],
    children: {},
  },
  [EDomainClass.SafetyAssessment]: {
    className: EDomainClass.SafetyAssessment,
    classNames: [EDomainClass.SafetyAssessment],
    children: {},
  },
  [EDomainClass.SafetyBarrier]: {
    className: EDomainClass.SafetyBarrier,
    classNames: [EDomainClass.SafetyBarrier],
    children: {},
  },
  [EDomainClass.SafetyCausalFactor]: {
    className: EDomainClass.SafetyCausalFactor,
    classNames: [EDomainClass.SafetyCausalFactor],
    children: {},
  },
  [EDomainClass.SafetyChangeApproval]: {
    className: EDomainClass.SafetyChangeApproval,
    classNames: [EDomainClass.SafetyChangeApproval],
    children: {},
  },
  [EDomainClass.SafetyConfiguration]: {
    className: EDomainClass.SafetyConfiguration,
    classNames: [EDomainClass.SafetyConfiguration],
    children: {},
  },
  [EDomainClass.SafetyConsequence]: {
    className: EDomainClass.SafetyConsequence,
    classNames: [EDomainClass.SafetyConsequence],
    children: {},
  },
  [EDomainClass.SafetyErcMatrix]: {
    className: EDomainClass.SafetyErcMatrix,
    classNames: [EDomainClass.SafetyErcMatrix],
    children: {},
  },
  [EDomainClass.SafetyExternalReportingToken]: {
    className: EDomainClass.SafetyExternalReportingToken,
    classNames: [EDomainClass.SafetyExternalReportingToken],
    children: {},
  },
  [EDomainClass.SafetyHazard]: {
    className: EDomainClass.SafetyHazard,
    classNames: [EDomainClass.SafetyHazard],
    children: {},
  },
  [EDomainClass.SafetyHazardSource]: {
    className: EDomainClass.SafetyHazardSource,
    classNames: [EDomainClass.SafetyHazardSource],
    children: {},
  },
  [EDomainClass.SafetyImportRun]: {
    className: EDomainClass.SafetyImportRun,
    classNames: [EDomainClass.SafetyImportRun],
    children: {},
  },
  [EDomainClass.SafetyInvestigation]: {
    className: EDomainClass.SafetyInvestigation,
    classNames: [EDomainClass.SafetyInvestigation],
    children: {},
  },
  [EDomainClass.SafetyInvestigationClosure]: {
    className: EDomainClass.SafetyInvestigationClosure,
    classNames: [EDomainClass.SafetyInvestigationClosure],
    children: {},
  },
  [EDomainClass.SafetyIssue]: {
    className: EDomainClass.SafetyIssue,
    classNames: [EDomainClass.SafetyIssue],
    children: {},
  },
  [EDomainClass.SafetyKeyPersonnel]: {
    className: EDomainClass.SafetyKeyPersonnel,
    classNames: [EDomainClass.SafetyKeyPersonnel],
    children: {},
  },
  [EDomainClass.SafetyLikelihoodBand]: {
    className: EDomainClass.SafetyLikelihoodBand,
    classNames: [EDomainClass.SafetyLikelihoodBand],
    children: {},
  },
  [EDomainClass.SafetyMeeting]: {
    className: EDomainClass.SafetyMeeting,
    classNames: [EDomainClass.SafetyMeeting],
    children: {},
  },
  [EDomainClass.SafetyMeetingAttendee]: {
    className: EDomainClass.SafetyMeetingAttendee,
    classNames: [EDomainClass.SafetyMeetingAttendee],
    children: {},
  },
  [EDomainClass.SafetyMeetingItem]: {
    className: EDomainClass.SafetyMeetingItem,
    classNames: [EDomainClass.SafetyMeetingItem],
    children: {},
  },
  [EDomainClass.SafetyOccurrence]: {
    className: EDomainClass.SafetyOccurrence,
    classNames: [EDomainClass.SafetyOccurrence],
    children: {},
  },
  [EDomainClass.SafetyOccurrenceStatusEntry]: {
    className: EDomainClass.SafetyOccurrenceStatusEntry,
    classNames: [EDomainClass.SafetyOccurrenceStatusEntry],
    children: {},
  },
  [EDomainClass.SafetyPerformanceIndicator]: {
    className: EDomainClass.SafetyPerformanceIndicator,
    classNames: [EDomainClass.SafetyPerformanceIndicator],
    children: {},
  },
  [EDomainClass.SafetyPublication]: {
    className: EDomainClass.SafetyPublication,
    classNames: [EDomainClass.SafetyPublication],
    children: {},
  },
  [EDomainClass.SafetyRecommendation]: {
    className: EDomainClass.SafetyRecommendation,
    classNames: [EDomainClass.SafetyRecommendation],
    children: {},
  },
  [EDomainClass.SafetyReport]: {
    className: EDomainClass.SafetyReport,
    classNames: [EDomainClass.SafetyReport],
    children: {},
  },
  [EDomainClass.SafetyReporterIdentity]: {
    className: EDomainClass.SafetyReporterIdentity,
    classNames: [EDomainClass.SafetyReporterIdentity],
    children: {},
  },
  [EDomainClass.SafetyReview]: {
    className: EDomainClass.SafetyReview,
    classNames: [EDomainClass.SafetyReview],
    children: {},
  },
  [EDomainClass.SafetyRisk]: {
    className: EDomainClass.SafetyRisk,
    classNames: [EDomainClass.SafetyRisk],
    children: {},
  },
  [EDomainClass.SafetyRiskAssessmentRecord]: {
    className: EDomainClass.SafetyRiskAssessmentRecord,
    classNames: [EDomainClass.SafetyRiskAssessmentRecord],
    children: {},
  },
  [EDomainClass.SafetySeverityDescriptor]: {
    className: EDomainClass.SafetySeverityDescriptor,
    classNames: [EDomainClass.SafetySeverityDescriptor],
    children: {},
  },
  [EDomainClass.SafetyTag]: {
    className: EDomainClass.SafetyTag,
    classNames: [EDomainClass.SafetyTag],
    children: {},
  },
  [EDomainClass.SpiObjective]: {
    className: EDomainClass.SpiObjective,
    classNames: [EDomainClass.SpiObjective],
    children: {},
  },
  [EDomainClass.SpiPeriodValue]: {
    className: EDomainClass.SpiPeriodValue,
    classNames: [EDomainClass.SpiPeriodValue],
    children: {},
  },
  [EDomainClass.BlockedSender]: {
    className: EDomainClass.BlockedSender,
    classNames: [EDomainClass.BlockedSender],
    children: {},
  },
  [EDomainClass.ChannelMessage]: {
    className: EDomainClass.ChannelMessage,
    classNames: [
      EDomainClass.ChannelMessage,
      EDomainClass.EmailMessage,
      EDomainClass.IMessageMessage,
      EDomainClass.InternalNoteMessage,
      EDomainClass.PhoneCallMessage,
      EDomainClass.WhatsAppMessage,
    ],
    children: {
      [EDomainClass.EmailMessage]: {
        className: EDomainClass.EmailMessage,
        classNames: [EDomainClass.EmailMessage],
        children: {},
      },
      [EDomainClass.IMessageMessage]: {
        className: EDomainClass.IMessageMessage,
        classNames: [EDomainClass.IMessageMessage],
        children: {},
      },
      [EDomainClass.InternalNoteMessage]: {
        className: EDomainClass.InternalNoteMessage,
        classNames: [EDomainClass.InternalNoteMessage],
        children: {},
      },
      [EDomainClass.PhoneCallMessage]: {
        className: EDomainClass.PhoneCallMessage,
        classNames: [EDomainClass.PhoneCallMessage],
        children: {},
      },
      [EDomainClass.WhatsAppMessage]: {
        className: EDomainClass.WhatsAppMessage,
        classNames: [EDomainClass.WhatsAppMessage],
        children: {},
      },
    },
  },
  [EDomainClass.ConversationDraft]: {
    className: EDomainClass.ConversationDraft,
    classNames: [EDomainClass.ConversationDraft],
    children: {},
  },
  [EDomainClass.ConversationThread]: {
    className: EDomainClass.ConversationThread,
    classNames: [EDomainClass.ConversationThread],
    children: {},
  },
  [EDomainClass.ConversationThreadMission]: {
    className: EDomainClass.ConversationThreadMission,
    classNames: [EDomainClass.ConversationThreadMission],
    children: {},
  },
  [EDomainClass.DispatchSettings]: {
    className: EDomainClass.DispatchSettings,
    classNames: [EDomainClass.DispatchSettings],
    children: {},
  },
  [EDomainClass.MessageAttachment]: {
    className: EDomainClass.MessageAttachment,
    classNames: [EDomainClass.MessageAttachment],
    children: {},
  },
  [EDomainClass.MessageReaction]: {
    className: EDomainClass.MessageReaction,
    classNames: [EDomainClass.MessageReaction],
    children: {},
  },
  [EDomainClass.ThreadEvent]: {
    className: EDomainClass.ThreadEvent,
    classNames: [EDomainClass.ThreadEvent],
    children: {},
  },
  [EDomainClass.ThreadRecipient]: {
    className: EDomainClass.ThreadRecipient,
    classNames: [EDomainClass.ThreadRecipient],
    children: {},
  },
  [EDomainClass.Todo]: {
    className: EDomainClass.Todo,
    classNames: [EDomainClass.Todo],
    children: {},
  },
  [EDomainClass.TodoCategory]: {
    className: EDomainClass.TodoCategory,
    classNames: [EDomainClass.TodoCategory],
    children: {},
  },
  [EDomainClass.TodoMessage]: {
    className: EDomainClass.TodoMessage,
    classNames: [EDomainClass.TodoMessage],
    children: {},
  },
  [EDomainClass.TodoRecurrence]: {
    className: EDomainClass.TodoRecurrence,
    classNames: [EDomainClass.TodoRecurrence],
    children: {},
  },
  [EDomainClass.TodoRecurrenceTarget]: {
    className: EDomainClass.TodoRecurrenceTarget,
    classNames: [EDomainClass.TodoRecurrenceTarget],
    children: {},
  },
  [EDomainClass.TodoTarget]: {
    className: EDomainClass.TodoTarget,
    classNames: [EDomainClass.TodoTarget],
    children: {},
  },
  [EDomainClass.AerodromeRequirement]: {
    className: EDomainClass.AerodromeRequirement,
    classNames: [EDomainClass.AerodromeRequirement],
    children: {},
  },
  [EDomainClass.Qualification]: {
    className: EDomainClass.Qualification,
    classNames: [EDomainClass.Qualification],
    children: {},
  },
  [EDomainClass.QualificationEvent]: {
    className: EDomainClass.QualificationEvent,
    classNames: [EDomainClass.QualificationEvent],
    children: {},
  },
  [EDomainClass.QualificationEventDocument]: {
    className: EDomainClass.QualificationEventDocument,
    classNames: [EDomainClass.QualificationEventDocument],
    children: {},
  },
  [EDomainClass.QualificationIssue]: {
    className: EDomainClass.QualificationIssue,
    classNames: [EDomainClass.QualificationIssue],
    children: {},
  },
  [EDomainClass.ScandlearnAccount]: {
    className: EDomainClass.ScandlearnAccount,
    classNames: [EDomainClass.ScandlearnAccount],
    children: {},
  },
  [EDomainClass.ScandlearnCertificate]: {
    className: EDomainClass.ScandlearnCertificate,
    classNames: [EDomainClass.ScandlearnCertificate],
    children: {},
  },
  [EDomainClass.ScandlearnSyncRun]: {
    className: EDomainClass.ScandlearnSyncRun,
    classNames: [EDomainClass.ScandlearnSyncRun],
    children: {},
  },
  [EDomainClass.ScandlearnTraining]: {
    className: EDomainClass.ScandlearnTraining,
    classNames: [EDomainClass.ScandlearnTraining],
    children: {},
  },
  [EDomainClass.TrainingAttestation]: {
    className: EDomainClass.TrainingAttestation,
    classNames: [EDomainClass.TrainingAttestation],
    children: {},
  },
  [EDomainClass.TrainingCategory]: {
    className: EDomainClass.TrainingCategory,
    classNames: [EDomainClass.TrainingCategory],
    children: {},
  },
  [EDomainClass.TrainingKind]: {
    className: EDomainClass.TrainingKind,
    classNames: [EDomainClass.TrainingKind],
    children: {},
  },
  [EDomainClass.TrainingQualificationSet]: {
    className: EDomainClass.TrainingQualificationSet,
    classNames: [EDomainClass.TrainingQualificationSet],
    children: {},
  },
  [EDomainClass.TrainingRecord]: {
    className: EDomainClass.TrainingRecord,
    classNames: [EDomainClass.TrainingRecord],
    children: {},
  },
  [EDomainClass.TrainingRecordDocument]: {
    className: EDomainClass.TrainingRecordDocument,
    classNames: [EDomainClass.TrainingRecordDocument],
    children: {},
  },
  [EDomainClass.TrainingSession]: {
    className: EDomainClass.TrainingSession,
    classNames: [EDomainClass.TrainingSession],
    children: {},
  },
  [EDomainClass.TrainingSessionAttendee]: {
    className: EDomainClass.TrainingSessionAttendee,
    classNames: [EDomainClass.TrainingSessionAttendee],
    children: {},
  },
  [EDomainClass.TrainingSessionDocument]: {
    className: EDomainClass.TrainingSessionDocument,
    classNames: [EDomainClass.TrainingSessionDocument],
    children: {},
  },
  [EDomainClass.TrainingSessionDutyRelease]: {
    className: EDomainClass.TrainingSessionDutyRelease,
    classNames: [EDomainClass.TrainingSessionDutyRelease],
    children: {},
  },
  [EDomainClass.TrainingSessionPresence]: {
    className: EDomainClass.TrainingSessionPresence,
    classNames: [EDomainClass.TrainingSessionPresence],
    children: {},
  },
  [EDomainClass.TrainingSessionSitting]: {
    className: EDomainClass.TrainingSessionSitting,
    classNames: [EDomainClass.TrainingSessionSitting],
    children: {},
  },
  [EDomainClass.TrainingSetControl]: {
    className: EDomainClass.TrainingSetControl,
    classNames: [EDomainClass.TrainingSetControl],
    children: {},
  },
  [EDomainClass.VppEventLog]: {
    className: EDomainClass.VppEventLog,
    classNames: [EDomainClass.VppEventLog],
    children: {},
  },
  [EDomainClass.VppUserAssignment]: {
    className: EDomainClass.VppUserAssignment,
    classNames: [EDomainClass.VppUserAssignment],
    children: {},
  },
  [EDomainClass.ChangeHistory]: {
    className: EDomainClass.ChangeHistory,
    classNames: [EDomainClass.ChangeHistory],
    children: {},
  },
  [EDomainClass.CarRefueling]: {
    className: EDomainClass.CarRefueling,
    classNames: [EDomainClass.CarRefueling],
    children: {},
  },
  [EDomainClass.HotelStay]: {
    className: EDomainClass.HotelStay,
    classNames: [EDomainClass.HotelStay],
    children: {},
  },
  [EDomainClass.Refueling]: {
    className: EDomainClass.Refueling,
    classNames: [EDomainClass.Refueling],
    children: {},
  },
  [EDomainClass.BelgianDepartingFlightTaxesExpenseItem]: {
    className: EDomainClass.BelgianDepartingFlightTaxesExpenseItem,
    classNames: [EDomainClass.BelgianDepartingFlightTaxesExpenseItem],
    children: {},
  },
  [EDomainClass.ItalianFlightTaxesExpenseItem]: {
    className: EDomainClass.ItalianFlightTaxesExpenseItem,
    classNames: [EDomainClass.ItalianFlightTaxesExpenseItem],
    children: {},
  },
  [EDomainClass.Organisation]: {
    className: EDomainClass.Organisation,
    classNames: [EDomainClass.Organisation],
    children: {},
  },
  [EDomainClass.Person]: {
    className: EDomainClass.Person,
    classNames: [EDomainClass.Person, EDomainClass.User],
    children: {
      [EDomainClass.User]: {
        className: EDomainClass.User,
        classNames: [EDomainClass.User],
        children: {},
      },
    },
  },
  [EDomainClass.AccountMouvementDocument]: {
    className: EDomainClass.AccountMouvementDocument,
    classNames: [
      EDomainClass.AccountMouvementDocument,
      EDomainClass.AccountMouvementFiscalDocument,
      EDomainClass.Expense,
      EDomainClass.BelgianDepartingFlightTaxesExpense,
      EDomainClass.ItalianFlightTaxesExpense,
      EDomainClass.StockIssueExpense,
      EDomainClass.Invoice,
      EDomainClass.AircraftOwnerInvoice,
      EDomainClass.MissionInvoice,
      EDomainClass.BelgianDepartingFlightTaxesExpense,
      EDomainClass.ItalianFlightTaxesExpense,
      EDomainClass.StockIssueExpense,
      EDomainClass.AircraftOwnerInvoice,
      EDomainClass.MissionInvoice,
      EDomainClass.DirectPosting,
      EDomainClass.Instalment,
      EDomainClass.IntermediaryAgencyPaymentCollection,
      EDomainClass.LoanMovement,
      EDomainClass.PersonalExpenseAccountMouvementDocument,
      EDomainClass.WagePayment,
      EDomainClass.Expense,
      EDomainClass.BelgianDepartingFlightTaxesExpense,
      EDomainClass.ItalianFlightTaxesExpense,
      EDomainClass.StockIssueExpense,
      EDomainClass.Invoice,
      EDomainClass.AircraftOwnerInvoice,
      EDomainClass.MissionInvoice,
      EDomainClass.BelgianDepartingFlightTaxesExpense,
      EDomainClass.ItalianFlightTaxesExpense,
      EDomainClass.StockIssueExpense,
      EDomainClass.AircraftOwnerInvoice,
      EDomainClass.MissionInvoice,
    ],
    children: {
      [EDomainClass.AccountMouvementFiscalDocument]: {
        className: EDomainClass.AccountMouvementFiscalDocument,
        classNames: [
          EDomainClass.AccountMouvementFiscalDocument,
          EDomainClass.Expense,
          EDomainClass.BelgianDepartingFlightTaxesExpense,
          EDomainClass.ItalianFlightTaxesExpense,
          EDomainClass.StockIssueExpense,
          EDomainClass.Invoice,
          EDomainClass.AircraftOwnerInvoice,
          EDomainClass.MissionInvoice,
          EDomainClass.BelgianDepartingFlightTaxesExpense,
          EDomainClass.ItalianFlightTaxesExpense,
          EDomainClass.StockIssueExpense,
          EDomainClass.AircraftOwnerInvoice,
          EDomainClass.MissionInvoice,
        ],
        children: {
          [EDomainClass.Expense]: {
            className: EDomainClass.Expense,
            classNames: [
              EDomainClass.Expense,
              EDomainClass.BelgianDepartingFlightTaxesExpense,
              EDomainClass.ItalianFlightTaxesExpense,
              EDomainClass.StockIssueExpense,
            ],
            children: {
              [EDomainClass.BelgianDepartingFlightTaxesExpense]: {
                className: EDomainClass.BelgianDepartingFlightTaxesExpense,
                classNames: [EDomainClass.BelgianDepartingFlightTaxesExpense],
                children: {},
              },
              [EDomainClass.ItalianFlightTaxesExpense]: {
                className: EDomainClass.ItalianFlightTaxesExpense,
                classNames: [EDomainClass.ItalianFlightTaxesExpense],
                children: {},
              },
              [EDomainClass.StockIssueExpense]: {
                className: EDomainClass.StockIssueExpense,
                classNames: [EDomainClass.StockIssueExpense],
                children: {},
              },
            },
          },
          [EDomainClass.Invoice]: {
            className: EDomainClass.Invoice,
            classNames: [
              EDomainClass.Invoice,
              EDomainClass.AircraftOwnerInvoice,
              EDomainClass.MissionInvoice,
            ],
            children: {
              [EDomainClass.AircraftOwnerInvoice]: {
                className: EDomainClass.AircraftOwnerInvoice,
                classNames: [EDomainClass.AircraftOwnerInvoice],
                children: {},
              },
              [EDomainClass.MissionInvoice]: {
                className: EDomainClass.MissionInvoice,
                classNames: [EDomainClass.MissionInvoice],
                children: {},
              },
            },
          },
          [EDomainClass.BelgianDepartingFlightTaxesExpense]: {
            className: EDomainClass.BelgianDepartingFlightTaxesExpense,
            classNames: [EDomainClass.BelgianDepartingFlightTaxesExpense],
            children: {},
          },
          [EDomainClass.ItalianFlightTaxesExpense]: {
            className: EDomainClass.ItalianFlightTaxesExpense,
            classNames: [EDomainClass.ItalianFlightTaxesExpense],
            children: {},
          },
          [EDomainClass.StockIssueExpense]: {
            className: EDomainClass.StockIssueExpense,
            classNames: [EDomainClass.StockIssueExpense],
            children: {},
          },
          [EDomainClass.AircraftOwnerInvoice]: {
            className: EDomainClass.AircraftOwnerInvoice,
            classNames: [EDomainClass.AircraftOwnerInvoice],
            children: {},
          },
          [EDomainClass.MissionInvoice]: {
            className: EDomainClass.MissionInvoice,
            classNames: [EDomainClass.MissionInvoice],
            children: {},
          },
        },
      },
      [EDomainClass.DirectPosting]: {
        className: EDomainClass.DirectPosting,
        classNames: [EDomainClass.DirectPosting],
        children: {},
      },
      [EDomainClass.Instalment]: {
        className: EDomainClass.Instalment,
        classNames: [EDomainClass.Instalment],
        children: {},
      },
      [EDomainClass.IntermediaryAgencyPaymentCollection]: {
        className: EDomainClass.IntermediaryAgencyPaymentCollection,
        classNames: [EDomainClass.IntermediaryAgencyPaymentCollection],
        children: {},
      },
      [EDomainClass.LoanMovement]: {
        className: EDomainClass.LoanMovement,
        classNames: [EDomainClass.LoanMovement],
        children: {},
      },
      [EDomainClass.PersonalExpenseAccountMouvementDocument]: {
        className: EDomainClass.PersonalExpenseAccountMouvementDocument,
        classNames: [EDomainClass.PersonalExpenseAccountMouvementDocument],
        children: {},
      },
      [EDomainClass.WagePayment]: {
        className: EDomainClass.WagePayment,
        classNames: [EDomainClass.WagePayment],
        children: {},
      },
      [EDomainClass.Expense]: {
        className: EDomainClass.Expense,
        classNames: [
          EDomainClass.Expense,
          EDomainClass.BelgianDepartingFlightTaxesExpense,
          EDomainClass.ItalianFlightTaxesExpense,
          EDomainClass.StockIssueExpense,
        ],
        children: {
          [EDomainClass.BelgianDepartingFlightTaxesExpense]: {
            className: EDomainClass.BelgianDepartingFlightTaxesExpense,
            classNames: [EDomainClass.BelgianDepartingFlightTaxesExpense],
            children: {},
          },
          [EDomainClass.ItalianFlightTaxesExpense]: {
            className: EDomainClass.ItalianFlightTaxesExpense,
            classNames: [EDomainClass.ItalianFlightTaxesExpense],
            children: {},
          },
          [EDomainClass.StockIssueExpense]: {
            className: EDomainClass.StockIssueExpense,
            classNames: [EDomainClass.StockIssueExpense],
            children: {},
          },
        },
      },
      [EDomainClass.Invoice]: {
        className: EDomainClass.Invoice,
        classNames: [
          EDomainClass.Invoice,
          EDomainClass.AircraftOwnerInvoice,
          EDomainClass.MissionInvoice,
        ],
        children: {
          [EDomainClass.AircraftOwnerInvoice]: {
            className: EDomainClass.AircraftOwnerInvoice,
            classNames: [EDomainClass.AircraftOwnerInvoice],
            children: {},
          },
          [EDomainClass.MissionInvoice]: {
            className: EDomainClass.MissionInvoice,
            classNames: [EDomainClass.MissionInvoice],
            children: {},
          },
        },
      },
      [EDomainClass.BelgianDepartingFlightTaxesExpense]: {
        className: EDomainClass.BelgianDepartingFlightTaxesExpense,
        classNames: [EDomainClass.BelgianDepartingFlightTaxesExpense],
        children: {},
      },
      [EDomainClass.ItalianFlightTaxesExpense]: {
        className: EDomainClass.ItalianFlightTaxesExpense,
        classNames: [EDomainClass.ItalianFlightTaxesExpense],
        children: {},
      },
      [EDomainClass.StockIssueExpense]: {
        className: EDomainClass.StockIssueExpense,
        classNames: [EDomainClass.StockIssueExpense],
        children: {},
      },
      [EDomainClass.AircraftOwnerInvoice]: {
        className: EDomainClass.AircraftOwnerInvoice,
        classNames: [EDomainClass.AircraftOwnerInvoice],
        children: {},
      },
      [EDomainClass.MissionInvoice]: {
        className: EDomainClass.MissionInvoice,
        classNames: [EDomainClass.MissionInvoice],
        children: {},
      },
    },
  },
  [EDomainClass.Payment]: {
    className: EDomainClass.Payment,
    classNames: [
      EDomainClass.Payment,
      EDomainClass.BankAccountPayment,
      EDomainClass.CashPayment,
      EDomainClass.CreditCardPayment,
      EDomainClass.ExactPayment,
      EDomainClass.ExactSettlementPayment,
      EDomainClass.IntermediaryAgencyPayment,
      EDomainClass.InternalPayment,
      EDomainClass.PersonalExpenseMonthlyStatementPayment,
      EDomainClass.PersonalExpensePayment,
    ],
    children: {
      [EDomainClass.BankAccountPayment]: {
        className: EDomainClass.BankAccountPayment,
        classNames: [EDomainClass.BankAccountPayment],
        children: {},
      },
      [EDomainClass.CashPayment]: {
        className: EDomainClass.CashPayment,
        classNames: [EDomainClass.CashPayment],
        children: {},
      },
      [EDomainClass.CreditCardPayment]: {
        className: EDomainClass.CreditCardPayment,
        classNames: [EDomainClass.CreditCardPayment],
        children: {},
      },
      [EDomainClass.ExactPayment]: {
        className: EDomainClass.ExactPayment,
        classNames: [EDomainClass.ExactPayment],
        children: {},
      },
      [EDomainClass.ExactSettlementPayment]: {
        className: EDomainClass.ExactSettlementPayment,
        classNames: [EDomainClass.ExactSettlementPayment],
        children: {},
      },
      [EDomainClass.IntermediaryAgencyPayment]: {
        className: EDomainClass.IntermediaryAgencyPayment,
        classNames: [EDomainClass.IntermediaryAgencyPayment],
        children: {},
      },
      [EDomainClass.InternalPayment]: {
        className: EDomainClass.InternalPayment,
        classNames: [EDomainClass.InternalPayment],
        children: {},
      },
      [EDomainClass.PersonalExpenseMonthlyStatementPayment]: {
        className: EDomainClass.PersonalExpenseMonthlyStatementPayment,
        classNames: [EDomainClass.PersonalExpenseMonthlyStatementPayment],
        children: {},
      },
      [EDomainClass.PersonalExpensePayment]: {
        className: EDomainClass.PersonalExpensePayment,
        classNames: [EDomainClass.PersonalExpensePayment],
        children: {},
      },
    },
  },
  [EDomainClass.AircraftOwnerInvoiceItem]: {
    className: EDomainClass.AircraftOwnerInvoiceItem,
    classNames: [EDomainClass.AircraftOwnerInvoiceItem],
    children: {},
  },
  [EDomainClass.FixedFeeShareCreditInvoiceItem]: {
    className: EDomainClass.FixedFeeShareCreditInvoiceItem,
    classNames: [EDomainClass.FixedFeeShareCreditInvoiceItem],
    children: {},
  },
  [EDomainClass.FixedFeeShareInvoiceItem]: {
    className: EDomainClass.FixedFeeShareInvoiceItem,
    classNames: [EDomainClass.FixedFeeShareInvoiceItem],
    children: {},
  },
  [EDomainClass.MissionInvoiceItem]: {
    className: EDomainClass.MissionInvoiceItem,
    classNames: [EDomainClass.MissionInvoiceItem],
    children: {},
  },
  [EDomainClass.MonthlyFeeDeductionDepositInvoiceItem]: {
    className: EDomainClass.MonthlyFeeDeductionDepositInvoiceItem,
    classNames: [EDomainClass.MonthlyFeeDeductionDepositInvoiceItem],
    children: {},
  },
  [EDomainClass.MonthlyFeeDepositInvoiceItem]: {
    className: EDomainClass.MonthlyFeeDepositInvoiceItem,
    classNames: [EDomainClass.MonthlyFeeDepositInvoiceItem],
    children: {},
  },
  [EDomainClass.StopRegularizationInvoiceItem]: {
    className: EDomainClass.StopRegularizationInvoiceItem,
    classNames: [EDomainClass.StopRegularizationInvoiceItem],
    children: {},
  },
  [EDomainClass.CategoryDutyAnalytics]: {
    className: EDomainClass.CategoryDutyAnalytics,
    classNames: [EDomainClass.CategoryDutyAnalytics],
    children: {},
  },
  [EDomainClass.CrewDutyAnalytics]: {
    className: EDomainClass.CrewDutyAnalytics,
    classNames: [EDomainClass.CrewDutyAnalytics],
    children: {},
  },
  [EDomainClass.CarResource]: {
    className: EDomainClass.CarResource,
    classNames: [EDomainClass.CarResource],
    children: {},
  },
  [EDomainClass.FuelCardResource]: {
    className: EDomainClass.FuelCardResource,
    classNames: [EDomainClass.FuelCardResource],
    children: {},
  },
  [EDomainClass.ITResource]: {
    className: EDomainClass.ITResource,
    classNames: [EDomainClass.ITResource],
    children: {},
  },
  [EDomainClass.SIMCardResource]: {
    className: EDomainClass.SIMCardResource,
    classNames: [EDomainClass.SIMCardResource],
    children: {},
  },
  [EDomainClass.CarResourceAssignment]: {
    className: EDomainClass.CarResourceAssignment,
    classNames: [EDomainClass.CarResourceAssignment],
    children: {},
  },
  [EDomainClass.Hotel]: {
    className: EDomainClass.Hotel,
    classNames: [EDomainClass.Hotel],
    children: {},
  },
  [EDomainClass.HotelBookingMeanMail]: {
    className: EDomainClass.HotelBookingMeanMail,
    classNames: [EDomainClass.HotelBookingMeanMail],
    children: {},
  },
  [EDomainClass.HotelBookingMeanThirdParty]: {
    className: EDomainClass.HotelBookingMeanThirdParty,
    classNames: [EDomainClass.HotelBookingMeanThirdParty],
    children: {},
  },
  [EDomainClass.HotelBookingMeanWebsite]: {
    className: EDomainClass.HotelBookingMeanWebsite,
    classNames: [EDomainClass.HotelBookingMeanWebsite],
    children: {},
  },
  [EDomainClass.PublicHolidayLeave]: {
    className: EDomainClass.PublicHolidayLeave,
    classNames: [EDomainClass.PublicHolidayLeave],
    children: {},
  },
  [EDomainClass.RosterLeaveUserAgenda]: {
    className: EDomainClass.RosterLeaveUserAgenda,
    classNames: [EDomainClass.RosterLeaveUserAgenda],
    children: {},
  },
  [EDomainClass.RosterTemplateUserAgenda]: {
    className: EDomainClass.RosterTemplateUserAgenda,
    classNames: [EDomainClass.RosterTemplateUserAgenda, EDomainClass.RosterChangeUserAgenda],
    children: {
      [EDomainClass.RosterChangeUserAgenda]: {
        className: EDomainClass.RosterChangeUserAgenda,
        classNames: [EDomainClass.RosterChangeUserAgenda],
        children: {},
      },
    },
  },
  [EDomainClass.BankAccountStatement]: {
    className: EDomainClass.BankAccountStatement,
    classNames: [EDomainClass.BankAccountStatement],
    children: {},
  },
  [EDomainClass.ExternalMonthlyStatement]: {
    className: EDomainClass.ExternalMonthlyStatement,
    classNames: [
      EDomainClass.ExternalMonthlyStatement,
      EDomainClass.CreditCardMonthlyStatement,
      EDomainClass.PersonalExpenseMonthlyStatement,
    ],
    children: {
      [EDomainClass.CreditCardMonthlyStatement]: {
        className: EDomainClass.CreditCardMonthlyStatement,
        classNames: [EDomainClass.CreditCardMonthlyStatement],
        children: {},
      },
      [EDomainClass.PersonalExpenseMonthlyStatement]: {
        className: EDomainClass.PersonalExpenseMonthlyStatement,
        classNames: [EDomainClass.PersonalExpenseMonthlyStatement],
        children: {},
      },
    },
  },
  [EDomainClass.BankAccount]: {
    className: EDomainClass.BankAccount,
    classNames: [EDomainClass.BankAccount],
    children: {},
  },
  [EDomainClass.CreditCard]: {
    className: EDomainClass.CreditCard,
    classNames: [EDomainClass.CreditCard],
    children: {},
  },
  [EDomainClass.Domiciliation]: {
    className: EDomainClass.Domiciliation,
    classNames: [EDomainClass.Domiciliation],
    children: {},
  },
  [EDomainClass.QuoteFuelConsumptionCalculationSupport]: {
    className: EDomainClass.QuoteFuelConsumptionCalculationSupport,
    classNames: [EDomainClass.QuoteFuelConsumptionCalculationSupport],
    children: {},
  },
  [EDomainClass.QuoteFuelPriceCalculationSupport]: {
    className: EDomainClass.QuoteFuelPriceCalculationSupport,
    classNames: [EDomainClass.QuoteFuelPriceCalculationSupport],
    children: {},
  },
  [EDomainClass.QuoteHandlingFeesCalculationSupport]: {
    className: EDomainClass.QuoteHandlingFeesCalculationSupport,
    classNames: [EDomainClass.QuoteHandlingFeesCalculationSupport],
    children: {},
  },
  [EDomainClass.QuoteRateCalculationSupport]: {
    className: EDomainClass.QuoteRateCalculationSupport,
    classNames: [EDomainClass.QuoteRateCalculationSupport],
    children: {},
  },
  [EDomainClass.UserAgendaFlightEvent]: {
    className: EDomainClass.UserAgendaFlightEvent,
    classNames: [EDomainClass.UserAgendaFlightEvent],
    children: {},
  },
  [EDomainClass.UserAgendaGroundCourseEvent]: {
    className: EDomainClass.UserAgendaGroundCourseEvent,
    classNames: [EDomainClass.UserAgendaGroundCourseEvent],
    children: {},
  },
  [EDomainClass.UserAgendaOfficeDutyEvent]: {
    className: EDomainClass.UserAgendaOfficeDutyEvent,
    classNames: [EDomainClass.UserAgendaOfficeDutyEvent],
    children: {},
  },
  [EDomainClass.UserAgendaPositioningEvent]: {
    className: EDomainClass.UserAgendaPositioningEvent,
    classNames: [EDomainClass.UserAgendaPositioningEvent],
    children: {},
  },
  [EDomainClass.UserAgendaPresenceEvent]: {
    className: EDomainClass.UserAgendaPresenceEvent,
    classNames: [EDomainClass.UserAgendaPresenceEvent],
    children: {},
  },
  [EDomainClass.UserAgendaTrainingEvent]: {
    className: EDomainClass.UserAgendaTrainingEvent,
    classNames: [EDomainClass.UserAgendaTrainingEvent],
    children: {},
  },
  [EDomainClass.EmailMessage]: {
    className: EDomainClass.EmailMessage,
    classNames: [EDomainClass.EmailMessage],
    children: {},
  },
  [EDomainClass.IMessageMessage]: {
    className: EDomainClass.IMessageMessage,
    classNames: [EDomainClass.IMessageMessage],
    children: {},
  },
  [EDomainClass.InternalNoteMessage]: {
    className: EDomainClass.InternalNoteMessage,
    classNames: [EDomainClass.InternalNoteMessage],
    children: {},
  },
  [EDomainClass.PhoneCallMessage]: {
    className: EDomainClass.PhoneCallMessage,
    classNames: [EDomainClass.PhoneCallMessage],
    children: {},
  },
  [EDomainClass.WhatsAppMessage]: {
    className: EDomainClass.WhatsAppMessage,
    classNames: [EDomainClass.WhatsAppMessage],
    children: {},
  },
  [EDomainClass.User]: {
    className: EDomainClass.User,
    classNames: [EDomainClass.User],
    children: {},
  },
  [EDomainClass.AccountMouvementFiscalDocument]: {
    className: EDomainClass.AccountMouvementFiscalDocument,
    classNames: [
      EDomainClass.AccountMouvementFiscalDocument,
      EDomainClass.Expense,
      EDomainClass.BelgianDepartingFlightTaxesExpense,
      EDomainClass.ItalianFlightTaxesExpense,
      EDomainClass.StockIssueExpense,
      EDomainClass.Invoice,
      EDomainClass.AircraftOwnerInvoice,
      EDomainClass.MissionInvoice,
      EDomainClass.BelgianDepartingFlightTaxesExpense,
      EDomainClass.ItalianFlightTaxesExpense,
      EDomainClass.StockIssueExpense,
      EDomainClass.AircraftOwnerInvoice,
      EDomainClass.MissionInvoice,
    ],
    children: {
      [EDomainClass.Expense]: {
        className: EDomainClass.Expense,
        classNames: [
          EDomainClass.Expense,
          EDomainClass.BelgianDepartingFlightTaxesExpense,
          EDomainClass.ItalianFlightTaxesExpense,
          EDomainClass.StockIssueExpense,
        ],
        children: {
          [EDomainClass.BelgianDepartingFlightTaxesExpense]: {
            className: EDomainClass.BelgianDepartingFlightTaxesExpense,
            classNames: [EDomainClass.BelgianDepartingFlightTaxesExpense],
            children: {},
          },
          [EDomainClass.ItalianFlightTaxesExpense]: {
            className: EDomainClass.ItalianFlightTaxesExpense,
            classNames: [EDomainClass.ItalianFlightTaxesExpense],
            children: {},
          },
          [EDomainClass.StockIssueExpense]: {
            className: EDomainClass.StockIssueExpense,
            classNames: [EDomainClass.StockIssueExpense],
            children: {},
          },
        },
      },
      [EDomainClass.Invoice]: {
        className: EDomainClass.Invoice,
        classNames: [
          EDomainClass.Invoice,
          EDomainClass.AircraftOwnerInvoice,
          EDomainClass.MissionInvoice,
        ],
        children: {
          [EDomainClass.AircraftOwnerInvoice]: {
            className: EDomainClass.AircraftOwnerInvoice,
            classNames: [EDomainClass.AircraftOwnerInvoice],
            children: {},
          },
          [EDomainClass.MissionInvoice]: {
            className: EDomainClass.MissionInvoice,
            classNames: [EDomainClass.MissionInvoice],
            children: {},
          },
        },
      },
      [EDomainClass.BelgianDepartingFlightTaxesExpense]: {
        className: EDomainClass.BelgianDepartingFlightTaxesExpense,
        classNames: [EDomainClass.BelgianDepartingFlightTaxesExpense],
        children: {},
      },
      [EDomainClass.ItalianFlightTaxesExpense]: {
        className: EDomainClass.ItalianFlightTaxesExpense,
        classNames: [EDomainClass.ItalianFlightTaxesExpense],
        children: {},
      },
      [EDomainClass.StockIssueExpense]: {
        className: EDomainClass.StockIssueExpense,
        classNames: [EDomainClass.StockIssueExpense],
        children: {},
      },
      [EDomainClass.AircraftOwnerInvoice]: {
        className: EDomainClass.AircraftOwnerInvoice,
        classNames: [EDomainClass.AircraftOwnerInvoice],
        children: {},
      },
      [EDomainClass.MissionInvoice]: {
        className: EDomainClass.MissionInvoice,
        classNames: [EDomainClass.MissionInvoice],
        children: {},
      },
    },
  },
  [EDomainClass.DirectPosting]: {
    className: EDomainClass.DirectPosting,
    classNames: [EDomainClass.DirectPosting],
    children: {},
  },
  [EDomainClass.Instalment]: {
    className: EDomainClass.Instalment,
    classNames: [EDomainClass.Instalment],
    children: {},
  },
  [EDomainClass.IntermediaryAgencyPaymentCollection]: {
    className: EDomainClass.IntermediaryAgencyPaymentCollection,
    classNames: [EDomainClass.IntermediaryAgencyPaymentCollection],
    children: {},
  },
  [EDomainClass.LoanMovement]: {
    className: EDomainClass.LoanMovement,
    classNames: [EDomainClass.LoanMovement],
    children: {},
  },
  [EDomainClass.PersonalExpenseAccountMouvementDocument]: {
    className: EDomainClass.PersonalExpenseAccountMouvementDocument,
    classNames: [EDomainClass.PersonalExpenseAccountMouvementDocument],
    children: {},
  },
  [EDomainClass.WagePayment]: {
    className: EDomainClass.WagePayment,
    classNames: [EDomainClass.WagePayment],
    children: {},
  },
  [EDomainClass.Expense]: {
    className: EDomainClass.Expense,
    classNames: [
      EDomainClass.Expense,
      EDomainClass.BelgianDepartingFlightTaxesExpense,
      EDomainClass.ItalianFlightTaxesExpense,
      EDomainClass.StockIssueExpense,
    ],
    children: {
      [EDomainClass.BelgianDepartingFlightTaxesExpense]: {
        className: EDomainClass.BelgianDepartingFlightTaxesExpense,
        classNames: [EDomainClass.BelgianDepartingFlightTaxesExpense],
        children: {},
      },
      [EDomainClass.ItalianFlightTaxesExpense]: {
        className: EDomainClass.ItalianFlightTaxesExpense,
        classNames: [EDomainClass.ItalianFlightTaxesExpense],
        children: {},
      },
      [EDomainClass.StockIssueExpense]: {
        className: EDomainClass.StockIssueExpense,
        classNames: [EDomainClass.StockIssueExpense],
        children: {},
      },
    },
  },
  [EDomainClass.Invoice]: {
    className: EDomainClass.Invoice,
    classNames: [
      EDomainClass.Invoice,
      EDomainClass.AircraftOwnerInvoice,
      EDomainClass.MissionInvoice,
    ],
    children: {
      [EDomainClass.AircraftOwnerInvoice]: {
        className: EDomainClass.AircraftOwnerInvoice,
        classNames: [EDomainClass.AircraftOwnerInvoice],
        children: {},
      },
      [EDomainClass.MissionInvoice]: {
        className: EDomainClass.MissionInvoice,
        classNames: [EDomainClass.MissionInvoice],
        children: {},
      },
    },
  },
  [EDomainClass.BelgianDepartingFlightTaxesExpense]: {
    className: EDomainClass.BelgianDepartingFlightTaxesExpense,
    classNames: [EDomainClass.BelgianDepartingFlightTaxesExpense],
    children: {},
  },
  [EDomainClass.ItalianFlightTaxesExpense]: {
    className: EDomainClass.ItalianFlightTaxesExpense,
    classNames: [EDomainClass.ItalianFlightTaxesExpense],
    children: {},
  },
  [EDomainClass.StockIssueExpense]: {
    className: EDomainClass.StockIssueExpense,
    classNames: [EDomainClass.StockIssueExpense],
    children: {},
  },
  [EDomainClass.AircraftOwnerInvoice]: {
    className: EDomainClass.AircraftOwnerInvoice,
    classNames: [EDomainClass.AircraftOwnerInvoice],
    children: {},
  },
  [EDomainClass.MissionInvoice]: {
    className: EDomainClass.MissionInvoice,
    classNames: [EDomainClass.MissionInvoice],
    children: {},
  },
  [EDomainClass.BankAccountPayment]: {
    className: EDomainClass.BankAccountPayment,
    classNames: [EDomainClass.BankAccountPayment],
    children: {},
  },
  [EDomainClass.CashPayment]: {
    className: EDomainClass.CashPayment,
    classNames: [EDomainClass.CashPayment],
    children: {},
  },
  [EDomainClass.CreditCardPayment]: {
    className: EDomainClass.CreditCardPayment,
    classNames: [EDomainClass.CreditCardPayment],
    children: {},
  },
  [EDomainClass.ExactPayment]: {
    className: EDomainClass.ExactPayment,
    classNames: [EDomainClass.ExactPayment],
    children: {},
  },
  [EDomainClass.ExactSettlementPayment]: {
    className: EDomainClass.ExactSettlementPayment,
    classNames: [EDomainClass.ExactSettlementPayment],
    children: {},
  },
  [EDomainClass.IntermediaryAgencyPayment]: {
    className: EDomainClass.IntermediaryAgencyPayment,
    classNames: [EDomainClass.IntermediaryAgencyPayment],
    children: {},
  },
  [EDomainClass.InternalPayment]: {
    className: EDomainClass.InternalPayment,
    classNames: [EDomainClass.InternalPayment],
    children: {},
  },
  [EDomainClass.PersonalExpenseMonthlyStatementPayment]: {
    className: EDomainClass.PersonalExpenseMonthlyStatementPayment,
    classNames: [EDomainClass.PersonalExpenseMonthlyStatementPayment],
    children: {},
  },
  [EDomainClass.PersonalExpensePayment]: {
    className: EDomainClass.PersonalExpensePayment,
    classNames: [EDomainClass.PersonalExpensePayment],
    children: {},
  },
  [EDomainClass.RosterChangeUserAgenda]: {
    className: EDomainClass.RosterChangeUserAgenda,
    classNames: [EDomainClass.RosterChangeUserAgenda],
    children: {},
  },
  [EDomainClass.CreditCardMonthlyStatement]: {
    className: EDomainClass.CreditCardMonthlyStatement,
    classNames: [EDomainClass.CreditCardMonthlyStatement],
    children: {},
  },
  [EDomainClass.PersonalExpenseMonthlyStatement]: {
    className: EDomainClass.PersonalExpenseMonthlyStatement,
    classNames: [EDomainClass.PersonalExpenseMonthlyStatement],
    children: {},
  },
} as const

export const DomainTreeSimplified = DomainTree as TDomainTree
export type TDomainTreeTyped = typeof DomainTree

export type TDomainClassNames<T extends keyof TDomainTreeTyped> =
  TDomainTreeTyped[T]['classNames'][number]
